import {toAbsoluteUrl} from '_metronic/helpers'

export * from './attendance'
export * from './library'
export * from './request'
export * from './tabManager'
export * from './user'

const constants = {
  session_db_postfix_key: 'active_session_postfix',

  api_base_url: import.meta.env.VITE_APP_API_URL ?? 'https://api.ilmversity.net/api/',
  //api_base_url: 'http://localhost:5000/api/',

  //api_platform_url: 'ilmversity.com',
  version: 'v1/',

  // notification polling
  notification_polling_delay: 1000 * 60 * 10,

  // user messages polling
  user_messages_polling_delay: 1000 * 30,

  // General Settings
  api_general_settings: 'general-settings',
  api_general_settings_subject_wise: 'general-settings/subject-wise-setting',

  // User API's
  api_get_all_users: 'user',

  // Settings
  api_id_card_settings: 'settings/id-card',
  api_staff_id_card_settings: 'settings/staff-id-card',
  api_enrollment_certificate_settings: 'settings/enrollment-certificate',
  api_outline_settings: 'settings/outline',
  api_comprehansive_settings: 'settings/comprehansive',
  api_predicted_settings: 'settings/predicted',
  api_ear_services: 'settings/ear-service',
  api_admission_settings: 'settings/admission',
  api_update_enable_admission_form: 'settings/enable-admission',

  // Tenant Sessions
  api_get_tenant_sessions: 'tenant-sessions',

  // file upload
  api_get_signed_upload_url: 'signed-url',
  api_confirm_file_upload: 'confirm-upload',

  // Login APIs
  api_login: 'user/login',
  api_login_jwt: 'user/login/jwt',
  api_universal_login: 'user/universal-login',
  api_universal_login_google: 'user/universal-login/google',
  api_admission_login: 'user/admission-login',
  api_admission_signup: 'admission/signup',
  api_admission_design: 'admission/design',

  // Admission form (applicant-facing, admission-user token)
  api_admission_form_config: 'admission/form-config',
  api_admission_form_data: 'admission/form-data',
  api_admission_form_field: 'admission/form-field',
  api_admission_siblings: 'admission/siblings',
  api_admission_academic_history: 'admission/academic-history',
  api_admission_subjects: 'admission/subjects',
  api_admission_answers: 'admission/answers',
  api_admission_signed_url: 'admission/signed-url',
  api_admission_confirm_upload: 'admission/confirm-upload',
  api_admission_profile_image: 'admission/profile-image',
  api_admission_documents: 'admission/documents',
  api_admission_document: (id: number) => `admission/documents/${id}`,
  api_admission_document_download: (id: number) => `admission/documents/${id}/download`,
  api_admission_terms_file: 'admission/terms-file',
  api_admission_submit: 'admission/submit',
  api_admission_downloads: 'admission/downloads',
  api_admission_form_download: 'admission/download/form',
  // Versi for applicants: same body/response as api_chatbot_chat, admission-user token
  api_admission_chat: 'admission/chat',
  // Versi on the public admission pages: same body/response, sent WITHOUT an Authorization header
  api_admission_public_chat: 'admission/public-chat',
  api_admission_parent_search: 'admission/parent-search',
  api_admission_parent_link: 'admission/parent-link',
  api_admission_parent_otp_send: 'admission/parent-otp-send',
  api_admission_parent_otp_verify: 'admission/parent-otp-verify',
  api_check_instances: 'user/check-instances',
  api_device_token: 'user/device-tokens',
  api_logout: 'user/logout',
  api_user_me: 'user/me',
  api_user_active_staff: 'user/active-staff',
  api_sms_services: 'user/sms-services',
  api_user_all_active_students: 'user/all-active-students',
  api_user_all_active_teachers: 'user/all-active-teachers',
  api_user_all_active_staff: 'user/all-active-staff',
  api_user_all_active_users_attendance: 'user/teacher-staff-attendance',
  api_user_all_active_students_attendance: 'user/students-attendance',
  api_user_all_active_students_attendance_by_grades: 'user/students-attendance-by-grades',
  api_notification_settings: 'school/notification-settings',
  api_email_settings: 'school/email-settings',
  api_user_teachers_subject_attendance: 'user/teachers-subject-attendance',
  api_user_students_subject_attendance: 'user/students-subject-attendance',
  api_inactive_users: 'user/inactivate',
  api_activate_users: 'user/activate',
  api_move_users_to_junk: 'user/move-to-junk',
  api_user_impersonate: 'user/impersonate',
  api_verify_password: 'user/verify-password',
  api_update_password: 'user/branchwise-password-change',
  api_regenerate_user_passwords: 'user/regenerate-password',

  // Forgot Password APIs
  api_forgot_password: 'user/forgot-password',
  api_verify_password_reset_otp: 'user/verify-password-reset-otp',
  api_verify_password_reset_google: 'user/verify-password-reset-google',
  api_reset_password: 'user/reset-password',
  api_reset_default_password: 'school/user/reset-default-password',

  // Send Feedback API
  api_feedback: 'user/send-feedback',

  // Chatbot API
  api_chatbot_chat: 'chatbot/chat',
  api_chatbot_voice_chat: 'chatbot/voice/chat',
  api_chatbot_voice_transcribe: 'chatbot/voice/transcribe',
  api_chatbot_recommended_voices: 'chatbot/voice/recommended-voices',

  api_get_branch_logo_signed_upload_url: 'school/branch/branch-logo-signed-upload-url',
  api_confirm_branch_logo_file_upload: 'school/branch/confirm-branch-logo-upload',
  api_get_branch_banner_signed_upload_url: 'school/branch/branch-banner-signed-upload-url',
  api_confirm_branch_banner_file_upload: 'school/branch/confirm-branch-banner-upload',
  api_check_branch_limit: 'school/branch/is-creation-allowed',

  api_get_departments: 'school/department',
  api_get_department: (id: number) => `school/department/${id}`,
  api_create_department: 'school/department/create',
  api_edit_department: (id: number) => `school/department/${id}`,
  api_delete_department: (id: number) => `school/department/${id}`,

  api_get_branches: 'school/user/branches',
  api_delete_branch: (id: number) => `school/branch/${id}`,

  // exam type
  api_get_all_exam_types: 'exam-type',

  //exam type labels
  api_exam_type_labels: 'examtypelabels',
  api_exam_type_labels_create: 'examtypelabels/create',
  api_exam_type_labels_delete_many: 'examtypelabels/delete-many',
  api_exam_type_labels_all: 'examtypelabels/all',

  // file type (document types)
  api_get_all_file_types: 'file-type',
  api_get_file_types_for_context: (context: string) => `file-type/context/${context}`,

  /**
   * Admission form settings APIs START
   */
  // Admission Form Sections settings
  api_admission_sections: 'school/admission/settings/sections',
  api_admission_section: (id: number) => `school/admission/settings/sections/${id}`,
  api_admission_section_fields: (id: number) => `school/admission/settings/sections/${id}/fields`,
  api_update_admission_setting_by_id: 'school/admission/settings/update-setting-by-id',
  api_admission_design_settings: 'school/admission/settings/design',

  // Admission form Subject Groups APIs
  api_get_subject_groups: 'school/admission/settings/subject_groups',
  api_get_subject_group: (id: number) => `school/admission/settings/subject_groups/${id}`,
  api_create_subject_group: 'school/admission/settings/subject_groups/create',
  api_edit_subject_group: (id: number) => `school/admission/settings/subject_groups/${id}`,
  api_delete_subject_group: (id: number) => `school/admission/settings/subject_groups/${id}`,

  // Admission form Subjects APIs
  api_get_admission_subjects: 'school/admission/settings/admission_subjects',
  api_get_admission_subject: (id: number) => `school/admission/settings/admission_subjects/${id}`,
  api_create_admission_subject: 'school/admission/settings/admission_subjects/create',
  api_edit_admission_subject: (id: number) => `school/admission/settings/admission_subjects/${id}`,
  api_delete_admission_subject: (id: number) =>
    `school/admission/settings/admission_subjects/${id}`,

  // Admission Questions APIs
  api_get_admission_questions: 'school/admission/settings/admission_questions',
  api_get_admission_question: (id: number) => `school/admission/settings/admission_questions/${id}`,
  api_create_admission_question: 'school/admission/settings/admission_questions/create',
  api_edit_admission_question: (id: number) =>
    `school/admission/settings/admission_questions/${id}`,
  api_delete_admission_question: (id: number) =>
    `school/admission/settings/admission_questions/${id}`,

  // Admission Subject Exams APIs
  api_get_admission_subject_exams: 'school/admission/settings/subject_exam',
  api_get_admission_subject_exam: (id: number) => `school/admission/settings/subject_exam/${id}`,
  api_create_admission_subject_exam: 'school/admission/settings/subject_exam/create',
  api_edit_admission_subject_exam: (id: number) => `school/admission/settings/subject_exam/${id}`,
  api_delete_admission_subject_exam: (id: number) => `school/admission/settings/subject_exam/${id}`,

  // Admission Subjects Grades APIs
  api_get_subjects_grades: 'school/admission/settings/subjects_grades',
  api_get_subjects_grade: (id: number) => `school/admission/settings/subjects_grades/${id}`,
  api_create_subjects_grade: 'school/admission/settings/subjects_grades/create',
  api_edit_subjects_grade: (id: number) => `school/admission/settings/subjects_grades/${id}`,
  api_delete_subjects_grade: (id: number) => `school/admission/settings/subjects_grades/${id}`,

  // Previous Subjects APIs
  api_get_admission_previous_subjects: 'school/admission/settings/previous_subjects',
  api_get_previous_subject: (id: number) => `school/admission/settings/previous_subjects/${id}`,
  api_create_previous_subject: 'school/admission/settings/previous_subjects/create',
  api_edit_previous_subject: (id: number) => `school/admission/settings/previous_subjects/${id}`,
  api_delete_previous_subject: (id: number) => `school/admission/settings/previous_subjects/${id}`,

  // Subject Combinations APIs
  api_get_subject_combinations: 'school/admission/settings/subject_combinations',
  api_get_subject_combination: (id: number) =>
    `school/admission/settings/subject_combinations/${id}`,
  api_create_subject_combination: 'school/admission/settings/subject_combinations/create',
  api_edit_subject_combination: (id: number) =>
    `school/admission/settings/subject_combinations/${id}`,
  api_delete_subject_combination: (id: number) =>
    `school/admission/settings/subject_combinations/${id}`,

  // Subject Components APIs
  api_get_subject_components: 'school/admission/settings/subject_components',
  api_get_subject_component: (id: number) => `school/admission/settings/subject_components/${id}`,
  api_create_subject_component: 'school/admission/settings/subject_components/create',
  api_edit_subject_component: (id: number) => `school/admission/settings/subject_components/${id}`,
  api_delete_subject_component: (id: number) =>
    `school/admission/settings/subject_components/${id}`,

  // Previous Classes APIs
  api_get_admission_previous_classes: 'school/admission/settings/previous_classes',
  api_get_previous_class: (id: number) => `school/admission/settings/previous_classes/${id}`,
  api_create_previous_class: 'school/admission/settings/previous_classes/create',
  api_edit_previous_class: (id: number) => `school/admission/settings/previous_classes/${id}`,
  api_delete_previous_class: (id: number) => `school/admission/settings/previous_classes/${id}`,
  api_update_previous_class_sequence: 'school/admission/settings/previous_classes/sequence',

  // Previous Schools APIs
  api_get_previous_schools: 'school/admission/settings/previous_schools',
  api_get_previous_school: (id: number) => `school/admission/settings/previous_schools/${id}`,
  api_create_previous_school: 'school/admission/settings/previous_schools/create',
  api_edit_previous_school: (id: number) => `school/admission/settings/previous_schools/${id}`,
  api_delete_previous_school: (id: number) => `school/admission/settings/previous_schools/${id}`,

  // Admission form Stages APIs
  api_get_admission_stages: 'school/admission/settings/admission_stages',
  api_get_admission_stage: (id: number) => `school/admission/settings/admission_stages/${id}`,
  api_edit_admission_stage: (id: number) => `school/admission/settings/admission_stages/${id}`,
  api_create_admission_stage: 'school/admission/settings/admission_stages/create',
  api_admission_stage_usage: (id: number) =>
    `school/admission/settings/admission_stages/${id}/usage`,
  api_delete_admission_stage: (id: number) => `school/admission/settings/admission_stages/${id}`,

  /**
   * Admission form settings APIs END
   */

  // Homework APIs
  api_get_homeworks: 'homework',
  api_get_homework_detail: 'homework/',
  api_homework_get_messages: '/messages/get',
  api_homework_send_messages: '/messages/send',
  api_get_signed_upload_url_homework: 'homework/signed-upload-url',
  api_confirm_file_upload_homework: 'homework/confirm-file-upload',
  api_delete_homework_file: 'homework/delete-student-file',
  api_submit_homework: 'homework/submit',
  api_get_all_homework: 'school/homework',
  api_get_homework: (id: string) => `school/homework/${id}`,
  api_add_homework: 'school/homework/create',
  api_add_homework_resource: 'school/homework/resources/create',
  api_delete_homework: (id: string) => `school/homework/${id}`,
  api_get_homework_resources: 'school/homework/resources',
  api_delete_homework_resource: (id: string) => `school/homework/resources/${id}`,
  api_update_homework: (id: string) => `school/homework/${id}`,
  api_delete_many_homeworks: 'school/homework/delete-many',
  api_add_many_homeworks: 'school/homework/multi-create',
  api_get_homework_reports: 'school/homework/reports',
  api_get_homework_results: (id: string) => `school/homework/${id}/results`,
  api_update_homework_results: 'school/homework/update-result',
  api_view_homework_submission: (id: string) => `school/homework/submission-files/${id}`,
  api_add_homework_feedback: 'school/homework/feedback-files/create',
  api_get_homework_feedback: (id: string) => `school/homework/feedback-files/${id}`,
  api_delete_homework_feedback: (id: string) => `school/homework/feedback-files/${id}`,
  api_assign_homework_marks_to_all: 'school/homework/bulk-assign-marks',
  api_assign_top_homeworks: 'school/homework/assign-top-homeworks',

  // Inventory Item Category APIs
  api_add_item: 'school/item-categories/create',
  api_update_item: (id: string) => `school/item-categories/${id}`,
  api_get_all_items: 'school/item-categories',
  api_delete_item_by_id: (id: string) => `school/item-categories/${id}`,
  api_get_item_by_id: (id: string) => `school/item-categories/${id}`,
  api_delete_items_in_bulk: 'school/item-categories/delete-many',

  // Inventory Store Items  APIs
  api_add_store_item: 'school/store-items/create',
  api_add_store_item_history: `school/store-items/history`,
  api_update_store_item: (id: string) => `school/store-items/${id}`,
  api_get_all_store_items: 'school/store-items',
  api_get_all_store_items_tags: 'school/store-items/tags',
  api_get_stock_report: 'school/store-items/stock-report',
  api_get_purchase_order_detail_report: 'school/store-items/purchase-order-report',
  api_get_issue_sold_stock_report: 'school/store-items/issued-sold-stock-report',
  api_get_all_store_items_permitted_tags: 'school/store-items/permitted-tags',
  api_scan_lookup_store_item: 'school/store-items/scan-lookup',
  api_generate_barcode_store_item: (id: string) => `school/store-items/${id}/generate-scan-code`,
  api_barcode_print_report: 'school/store-items/barcode-print-report',
  api_delete_store_item_by_id: (id: string) => `school/store-items/${id}`,
  api_get_store_item_by_id: (id: string) => `school/store-items/${id}`,
  api_delete_store_item_in_bulk: 'school/store-items/delete-many',
  api_transfer_item_type: 'school/store-items/transfer',
  api_get_transfer_item_list: 'school/store-items/transfer-items-list',
  // Inventory Store Items Packages  APIs
  api_add_store_item_package: 'school/packages/create',
  api_update_store_item_package: (id: string) => `school/packages/${id}`,
  api_get_all_store_items_package: 'school/packages',
  api_delete_store_item_package_by_id: (id: string) => `school/packages/${id}`,
  api_get_store_item_package_by_id: (id: string) => `school/packages/${id}`,
  api_delete_store_item_package_in_bulk: 'school/packages/delete-many',

  // purchase order urls
  api_get_purchase_orders: 'school/purchase-orders',
  api_get_purchase_order: (id: number) => `school/purchase-orders/${id}`,
  api_add_purchase_order: 'school/purchase-orders/create',
  api_update_purchase_order: (id: number) => `school/purchase-orders/${id}`,
  api_delete_purcahse_order_by_id: (id: number) => `school/purchase-orders/${id}`,
  api_delete_purcahse_order_in_bulk: 'school/purchase-orders/delete-many',
  api_get_purchase_order_report: (id: number) =>
    `school/purchase-orders/${id}/purchase-order-report`,

  // goods receipt urls
  api_get_goods_receipts: 'school/goods-receipts',
  api_get_goods_receipt: (id: number) => `school/goods-receipts/${id}`,
  api_update_goods_receipt: (id: number) => `school/goods-receipts/${id}`,
  api_add_goods_receipt: 'school/goods-receipts/create',
  api_delete_goods_receipt_by_id: (id: number) => `school/goods-receipts/${id}`,
  api_delete_goods_receipt_in_bulk: 'school/goods-receipts/delete-many',
  api_get_goods_receipt_report_by_id: (id: string) =>
    `school/goods-receipts/${id}/goods-receipt-report`,

  // invoices urls
  api_get_invoices: 'school/invoices',
  // Admission Vouchers
  api_get_admission_vouchers: 'school/admission-vouchers',
  api_get_invoice: (id: number) => `school/invoices/${id}`,
  api_add_invoice: 'school/invoices/create',
  api_update_invoice: (id: string) => `school/invoices/${id}`,
  api_delete_invoice_by_id: (id: number) => `school/invoices/${id}`,
  api_delete_invoices_in_bulk: 'school/invoices/delete-many',
  api_get_invoice_report_by_id: (id: string) => `school/invoices/${id}/invoice-report`,

  //inventorySettings urls
  api_get_inventory_settings: 'school/inventory-settings',
  api_update_inventory_settings: 'school/inventory-settings/update',

  // Setting APIs
  api_setting: 'user/user-settings', //set and get

  api_get_profile_picture_upload_url: 'user/profile-picture/signed-url',
  api_get_user_profile_picture_upload_url: (id: string) => `user/${id}/profile-picture/signed-url`,
  api_confirm_profile_picture_upload: 'user/profile-picture/confirm-upload',
  api_confirm_profile_picture_upload_any_user: (id: string) =>
    `user/${id}/profile-picture/confirm-upload`,

  // UserSecurityDetails APIs
  api_verify_student_parent_email: 'user-security-details/verify-student-parent-email',
  api_bulk_send_student_parent_verification:
    'user-security-details/bulk-send-student-parent-verification',

  // General APIs
  api_get_user_subjects: 'user/subjects',
  api_post_student_subjects: 'subjects/students',

  // Profile APIs
  api_get_profile: 'user/profile-details',
  api_get_child_profile: 'user/child-profile',

  // Lecture APIs
  api_get_lectures: 'school/lecture/getAll',
  api_get_lecture_detail: (id: string) => `school/lecture/${id}`,
  api_delete_lecture: (id: string) => `school/lecture/${id}`,
  api_add_lecture: 'school/lecture/create',
  api_update_lecture: (id: string) => `school/lecture/${id}`,
  api_get_online_user: (id: string) => `school/lecture/${id}/onlineUser`,
  api_add_comment: (id: string) => `school/lecture/${id}/comment`,
  api_update_comment: (id: string) => `school/lecture/comment/${id}`,
  api_delete_comment: (id: string) => `school/lecture/deleteComment/${id}`,
  api_get_all_lecture_comments: (id: string) => `school/lecture/comments/${id}`,

  //ScheduleAPis
  api_get_yearlySchedule: 'schedule/yearly/calendar',
  api_get_dailyScheduleActivities: 'schedule/daily/calendar/activitieswise',
  api_get_dailyScheduleClasswise: 'schedule/daily/calendar/classwise',
  api_get_dailyScheduleTeacherwise: 'schedule/daily/calendar/teacherwise',
  api_get_dailyScheduleStudentwise: 'schedule/daily/calendar/studentwise',
  api_get_yearlyList: 'schedule/yearly',
  api_add_ySchedule: 'schedule/yearly/create',
  api_add_dSchedule: 'schedule/daily/create',
  api_add_classroom: 'schedule/daily/class/create',
  api_get_dailyList: 'schedule/daily',
  api_get_classList: 'schedule/daily/class',
  api_add_extraclass: 'schedule/daily/extra-class',
  api_delete_Yschedule: (id: string) => `schedule/yearly/delete/${id}`,
  api_delete_many_Yschedule: `schedule/yearly/delete-many`,
  api_delete_Dschedule: (id: string) => `schedule/daily/delete/${id}`,
  api_delete_many_Dschedule: `schedule/daily/delete-many`,
  api_delete_DscheduleClasses: (id: string) => `schedule/daily/class/delete/${id}`,
  api_get_ClassroomById: (id: string) => `schedule/daily/class/${id}`,
  api_get_yScheduleById: (id: string) => `schedule/yearly/${id}`,
  api_get_dScheduleById: (id: string) => `schedule/daily/${id}`,
  api_update_ySchedule: (id: string) => `schedule/yearly/update/${id}`,
  api_update_dSchedule: (id: string) => `schedule/daily/update/${id}`,
  api_update_classRoom: (id: string) => `schedule/daily/class/update/${id}`,

  //Notifications APIs
  api_get_notifications: 'user/notifications',
  api_get_new_notifications_count: 'user/notifications/count',
  api_read_notifications: 'user/notifications/read',
  api_read_all_notifications: 'user/notifications/read-all',

  //News APIs
  api_add_news: 'news/create',
  api_update_news: (id: string) => `news/${id}`,
  api_send_news_notifications: (id: string) => `news/${id}/notifications`,
  api_send_news_sms: (id: string) => `news/${id}/sms`,
  api_news_approval_status: (id: string) => `news/${id}/approval-status`,
  api_news_approval_info: (id: string) => `news/${id}/approval-info`,
  api_get_all_news: 'news',
  api_delete_news_by_id: (id: string) => `news/${id}`,
  api_delete_news_cover_by_id: (id: string) => `news/${id}/destroy-cover-image`,
  api_delete_news_attachment_by_id: (id: string) => `news/${id}/destroy-attachment`,
  api_get_news_by_id: (id: string) => `news/${id}`,
  api_delete_news_in_bulk: 'news/delete-many',
  api_generate_news_report: 'news/generate-reports',

  //Event APIs
  api_event: 'events',

  //Sports Record APIs
  api_sports_record: 'sports',
  //College Counselling APIs
  api_counselling: 'counselling',
  //Diagnose APIs
  api_diagnose: 'school/diagnose',

  //Fee APIs (student/parent fee vouchers — node proxies the legacy fee API)
  api_portal_fee_history: 'fee/portal/history',
  api_portal_fee_voucher: 'fee/portal/voucher',
  api_student_profile_fee_particulars: 'fee/student-profile-fee-particulars',
  api_get_class_fee_package_details: (id: string) => `fee/class-fee-package-details/${id}`,

  // user gender
  user_gender_male: 0,
  user_gender_female: 1,

  //userManager
  //Student apis
  api_update_student_generalRById: (id: string) => `student/remarks/general/${id}`,
  api_update_student_subjectRyId: (id: string) => `student/remarks/subject/${id}`,
  api_update_student_ById: (id: string) => `student/${id}/update`,
  api_get_student_generalRById: (id: string) => `student/${id}/remarks/general`,
  api_add_studentSportRemarksById: (id: string) => `student/${id}/sports/remarks`,
  api_get_student_subjectRyId: (id: string) => `student/${id}/remarks/subject`,
  api_add_student_generalRById: (id: string) => `student/${id}/remarks/general/create`,
  api_add_student_subjectRyId: (id: string) => `student/${id}/remarks/subject/create`,
  api_get_students: 'student',
  api_inactivate_student: (id: number | string) => `student/${id}/inactivate`,
  api_get_student_mini_profile: 'student/mini-profile',
  api_get_student_number: 'student/latest-number',
  api_get_student_file_types: 'student/file-types',
  api_add_upload_file: (id: string) => `student/${id}/files/upload`,
  api_add_student_sport: `student/add/sport`,
  api_add_student_sport_by_id: `student/sports/assign`,
  api_get_new_admission_student: 'student/new-admission',
  api_admission_report_filters: 'school/admission/report/filters',
  api_admission_report_summary: 'school/admission/report/summary',
  api_admission_report_applicants: 'school/admission/report/applicants',
  api_admission_report_export: 'school/admission/report/export',
  api_admission_status_change: 'school/admission/status/change',
  api_admission_status_change_bulk: 'school/admission/status/change-bulk',
  api_admission_status_letter_preview: 'school/admission/status/letter-preview',
  api_new_admission_answers_report: 'student/new-admission-answers-report',
  api_get_class_history: (id: number) => `student/${id}/class-history`,
  api_create_class_history: (id: number) => `student/${id}/create-class-history`,
  api_get_academic_record: (id: number) => `student/${id}/academic-record`,
  api_get_counsellor_mentor: `student/counsellor-mentor`,
  api_get_donars: `student/donars`,

  api_generate_student_list_report: 'student/generate-students-list',
  api_generate_student_promotion_report: 'student/generate-promotion-report',
  api_generate_student_information_report: 'student/generate-information-report',
  api_generate_student_login_report: 'student/generate-students-login-report',
  api_sms_login_details: 'student/sms-login-details',
  api_email_login_details: 'student/email-login-details',
  api_add_student_siblings: 'student/add-siblings',
  api_get_student_sports: 'student/sports',
  api_create_student: 'student/create',
  api_get_student: (id: string) => `student/${id}`,
  api_get_student_parent: (id: string) => `student/${id}/parents`,
  api_get_student_academics: (id: string) => `student/${id}/academics`,
  api_get_student_academics_previous_exams: (id: string) =>
    `student/${id}/academics/exams/previous`,
  api_get_student_academics_exams: (id: string) => `student/${id}/academics/exams`,
  api_get_student_academics_tests: (id: string) => `student/${id}/academics/tests`,
  api_get_student_academic_homeworks: (id: string) => `student/${id}/academics/homework`,
  api_get_student_fees: (id: string) => `student/${id}/fees`,
  api_get_student_sports_remarks: (id: string) => `student/${id}/sport-remarks`,
  api_update_student_sports_remarks: (id: string) => `student/remarks/sport/${id}`,
  api_delete_student_sport_remarks: (id: string) => `student/${id}/remarks/destroy/sport`,
  api_get_student_subject_combination: (id: string) => `student/${id}/subject-combination`,
  api_update_student_subject_combination: (id: string) => `student/${id}/subject-combination`,
  api_get_student_user_id: (id: string) => `student/${id}/user-id`,
  api_get_student_siblings: (id: string) => `student/${id}/siblings`,
  api_get_student_homework: (id: string) => `student/${id}/homework/assigned`,
  api_get_student_subjects: (id: string) => `student/${id}/subjects`,
  api_get_student_tests: (id: string) => `student/${id}/tests/assigned`,
  api_get_student_exams: (id: string) => `student/${id}/exams/assigned`,
  api_get_student_homework_unassigned: (id: string) => `student/${id}/homework/unassigned`,
  api_get_student_tests_unassigned: (id: string) => `student/${id}/tests/unassigned`,
  api_get_student_exams_unassigned: (id: string) => `student/${id}/exams/unassigned`,
  api_add_student_homework_assign: (id: string) => `student/${id}/homework/assign`,
  api_add_student_tests_assign: (id: string) => `student/${id}/tests/assign`,
  api_add_student_exams_assign: (id: string) => `student/${id}/exams/assign`,
  api_get_student_descriptions: (id: string) => `student/${id}/descriptions`,
  api_delete_student_records: (id: string) => `student/${id}/records`,
  api_delete_student_general_remarks: (id: string) => `student/${id}/remarks/destroy/general`,
  api_delete_student_subject_remarks: (id: string) => `student/${id}/remarks/destroy/subject`,
  api_delete_student_homework: (id: string) => `student/homework/destroy/${id}`,
  api_delete_student_test: (id: string) => `student/tests/destroy/${id}`,
  api_delete_student_exam: (id: string) => `student/exams/destroy/${id}`,
  api_get_uploaded_student_file: (id: string) => `student/${id}/files/uploaded`,
  api_delete_uploaded_file: `student/files/uploaded`,
  api_update_uploaded_file_type: `student/files/uploaded`,

  // parent
  api_add_parent: 'parent/create',
  api_sms_parent_login_details: 'parent/sms-login-details',
  api_email_parent_login_details: 'parent/email-login-details',
  api_generate_parent_login_report: 'parent/generate-parents-login-report',
  api_generate_parent_sibling_report_pdf: 'parent/sibling-report-pdf',
  api_generate_parent_sibling_report_excel: 'parent/sibling-report-excel',
  api_add_parent_emergency_contacts: 'parent/add-emergency-contacts',
  api_update_parent_ById: (id: string) => `parent/update/${id}`,
  api_get_parents: 'parent',
  api_get_parent: (id: string) => `parent/${id}`,
  api_get_parent_children: (id: string) => `parent/${id}/children`,
  api_get_parent_emergency_contacts: (id: string) => `parent/${id}/emergency-contacts`,
  api_delete_childless_parents: 'parent/delete-childless',

  // teacher routes
  api_update_teacher_by_id: (id: string) => `teacher/update/${id}`,
  api_create_teacher: 'teacher/create',
  api_get_teacher_list: 'teacher',
  api_get_teacher_assigned_students: 'teacher/assigned-students',
  api_in_activate_teacher_by_id: (id: string) => `teacher/${id}/inactivate`,
  api_get_teacher_info_by_id: (id: string) => `teacher/${id}`,
  api_get_teacher_classes_by_id: (id: string) => `teacher/${id}/classes`,
  api_get_teacher_subjects_by_id: (id: string) => `teacher/${id}/subjects`,
  api_get_teacher_qualification_by_id: (id: string) => `teacher/${id}/qualifications`,
  api_get_teacher_experience_by_id: (id: string) => `teacher/${id}/experiences`,
  api_get_teacher_children_by_id: (id: string) => `teacher/${id}/children`,
  api_del_teacher_destroy_general_remarks: (id: string) => `teacher/${id}/remarks/destroy/general`,
  api_get_teacher_general_remarks_by_id: (id: string) => `teacher/${id}/remarks/general`,
  api_add_teacher_general_remarks_by_id: (id: string) => `teacher/${id}/remarks/general/create`,
  api_update_teacher_general_remarks_ById: (id: string) => `teacher/remarks/general/${id}`,
  api_get_teacher_uploaded_files: (id: string) => `teacher/${id}/files/uploaded`,
  api_get_teacher_file_types: 'teacher/file-types',
  api_add_teacher_upload_file: (id: string) => `teacher/${id}/files/upload`,
  api_sms_teacher_login_details: 'teacher/sms-login-details',
  api_email_teacher_login_details: 'teacher/email-login-details',
  api_generate_teacher_login_report: 'teacher/generate-teachers-login-report',
  api_generate_teacher_list_report_pdf: 'teacher/generate-teacher-list-report-pdf',
  api_generate_teacher_list_report_excel: 'teacher/generate-teacher-list-report-excel',
  api_confirm_signature_picture_upload: (id: string) =>
    `teacher/${id}/signature-picture/confirm-upload `,

  // staff routes
  api_get_all_user_staff: 'staff',
  api_create_staff: 'staff/create',
  api_get_staff: (id: number) => `staff/${id}`,
  api_update_staff: (id: number) => `staff/${id}`,
  api_get_staff_qualifications: (id: number) => `staff/${id}/qualifications`,
  api_get_staff_experiences: (id: number) => `staff/${id}/experiences`,
  api_get_staff_children: (id: number) => `staff/${id}/children`,
  api_confirm_staff_signature_upload: (id: number) => `staff/${id}/signature/confirm-upload `,
  api_upload_user_docs: `staff/upload-docs`,
  api_get_uploaded_docs: `staff/uploaded-docs`,
  api_sms_staff_login_details: 'staff/sms-login-details',
  api_email_staff_login_details: 'staff/email-login-details',
  api_generate_staff_list_report_pdf: 'staff/generate-staff-list-report-pdf',
  api_generate_staff_list_report_excel: 'staff/generate-staff-list-report-excel',
  api_generate_staff_login_report: 'staff/generate-staff-login-report',

  // school routes
  api_edit_school_user_profile: 'school/user/profile',
  api_get_institute_info: 'school/applications',
  api_update_institute_info: 'school/applications',

  api_change_school_user_password: 'school/user/change-password',

  api_get_user_qualifications: 'school/user/qualifications',
  api_add_user_qualifications: 'school/user/qualifications',

  api_get_user_experiences: 'school/user/experiences',
  api_add_user_experiences: 'school/user/experiences',

  api_get_user_children: 'school/user/children',
  api_add_user_children: 'school/user/children',

  api_get_user_bank_info: 'school/user/bank-info',
  api_update_user_bank_info: 'school/user/bank-info',

  // vendor urls
  api_get_vendors: 'school/vendor',
  api_get_vendor: (id: string) => `school/vendor/${id}`,
  api_add_vendor: 'school/vendor/create',
  api_update_vendors: (id: string) => `school/vendor/${id}`,
  api_delete_vendor: (id: string) => `school/vendor/${id}`,
  api_register_vendor: (id: string) => `school/vendor/${id}/register`,
  api_get_vendor_signed_upload_url: 'school/vendor/signed-upload-url',
  api_delete_vendor_old_cnic_files: (id: string) => `school/vendor/delete-cnic/${id}`,
  api_confirm_vendor_file_upload: 'school/vendor/confirm-file-upload',

  // vendor settings urls
  api_get_vendor_settings: 'school/vendor-settings',
  api_update_vendor_settings: 'school/vendor-settings',

  // inventory dashboard url
  api_get_inventory_dashboard_summary: 'school/inventory-dashboard/summary',

  // stock ledger urls
  api_get_stock_ledger: 'school/stock-ledger',
  api_get_stock_ledger_movement_types: 'school/stock-ledger/movement-types',

  api_get_user_messages: 'messages/user',
  api_get_account_list: 'school/accounts',

  api_get_account_types: 'school/account-types',
  api_get_logs: 'school/dbLog',
  api_get_sms_logs: 'school/smsLog',
  api_get_account_type: (id: string) => `school/account-types/${id}`,
  api_get_whatsapp_logs: 'school/whatsappLog',

  api_get_notification_logs: 'school/notificationLog',
  api_get_biometric_csv_logs: 'school/biometricCsvLog',
  api_get_biometric_device_logs: 'school/biometricDeviceLog',
  api_get_biometric_logs: 'school/biometricLog',

  // Threads
  api_get_threads: 'threads',
  api_create_threads: 'threads/create',
  api_get_thread_messages: (id: string) => `threads/${id}/messages`,
  api_read_thread_messages: (id: string) => `threads/${id}/read-messages`,

  api_send_message: `messages/send`,

  // Messaging module
  api_get_messaging_contacts: 'messages/contacts',
  api_search_messages: 'messages/search',
  api_report_message: 'messages/report',
  api_block_messaging_user: 'messages/block',
  api_unblock_messaging_user: (userId: number) => `messages/block/${userId}`,
  api_set_messaging_office_hours: 'messages/office-hours',
  api_add_thread_participants: (id: number) => `threads/${id}/participants`,
  api_mute_thread: (id: number) => `threads/${id}/mute`,
  api_messaging_admin_threads: 'messages/admin/threads',
  api_messaging_admin_reports: 'messages/admin/reports',
  api_messaging_admin_report: (id: number) => `messages/admin/reports/${id}`,
  api_messaging_admin_blocks: 'messages/admin/blocks',
  api_messaging_admin_suspend: 'messages/admin/suspend',
  api_messaging_admin_settings: 'messages/admin/settings',

  // Request Module urls
  // request urls
  api_get_requests: 'school/requests',
  api_get_request: (id: number) => `school/requests/${id}`,
  api_add_request: 'school/requests/create',
  api_update_request: (id: number) => `school/requests/${id}`,
  api_delete_request: (id: number) => `school/requests/${id}`,
  api_get_smslog: (id: number) => `school/smsLog/${id}`,
  api_get_notificationlog: (id: number) => `school/notificationLog/${id}`,

  api_get_request_signed_upload_url: 'school/requests/signed-upload-url',
  api_confirm_request_file_upload: 'school/requests/confirm-file-upload',
  api_delete_request_attachment: (requestId: number, attachmentId: number) =>
    `school/requests/${requestId}/attachments/${attachmentId}`,

  // request settings urls
  api_get_request_settings: 'school/request-settings',
  api_update_request_settings: 'school/request-settings',

  // permission urls
  api_get_permissions: 'school/permissions',
  api_get_permission: (id: number) => `school/permissions/${id}`,

  // role module permissions urls
  api_add_role_module_permission: 'school/role-module-permission/create',
  api_get_role_module_permission_by_level: (level_id: number) =>
    `school/role-module-permission/by-level/${level_id}`,
  api_delete_role_module_permissions_by_level: (level_id: number) =>
    `school/role-module-permission/${level_id}`,

  // transaction urls
  api_get_transactions: 'school/transactions',
  api_get_transaction: (id: number) => `school/transactions/${id}`,

  // transaction urls
  api_get_all_staff: 'school/user/staff',
  api_get_one_staff: (id: number) => `school/user/staff/${id}`,

  // Certificate Module urls
  // certificate urls
  api_get_certificates: 'school/letters',
  api_get_certificate: (id: number) => `school/letters/${id}`,
  api_add_certificate: 'school/letters/create',
  api_update_certificate: (id: number) => `school/letters/${id}`,
  api_delete_certificate: (id: number) => `school/letters/${id}`,
  api_generate_certificate: 'school/letters/generate-certificate',

  // label urls
  api_get_labels: 'school/labels',
  api_search_labels: 'school/labels/search',
  api_get_label: (id: number) => `school/labels/${id}`,
  api_create_labels: 'school/labels/create',
  api_update_label: (id: number) => `school/labels/${id}`,
  api_delete_label: (id: number) => `school/labels/${id}`,
  api_delete_all_labels: 'school/labels/delete-all',
  api_student_label_report: 'school/labels/student-label-report',
  api_teacher_house_color_report: 'school/labels/teacher-house-color-report',

  // class urls
  api_get_classes: 'school/classes',
  api_get_users_active_classes: 'school/get-users-active-classes',
  api_get_class: (id: number) => `school/classes/${id}`,
  api_add_class: 'school/classes/create',
  api_delete_class: (id: number) => `school/classes/${id}`,
  api_inactivate_class: (id: number) => `school/classes/${id}/inactivate`,
  api_delete_many_classes: 'school/classes/delete-many',
  api_update_class: (id: number) => `school/classes/${id}`,
  api_get_class_resources: `school/classes/resources`,
  api_add_class_resource: 'school/classes/resources/create',
  api_get_class_subjects: (id: number) => `school/classes/${id}/subjects`,
  api_get_class_students: (id: number) => `school/classes/${id}/students`,
  api_get_students_from_multiple_classes: 'school/classes/students-from-multiple-classes',
  api_delete_class_resource: (id: number) => `school/classes/resources/${id}`,
  api_get_class_sequence: 'school/classes/class-sequence',
  api_update_class_sequence: 'school/classes/sequence',
  api_generate_class_strength_list: 'school/classes/strength',
  api_promote_students: 'school/classes/promote-students',
  api_get_previous_classes: 'school/classes/previous-classes',
  api_assign_teachers: 'school/classes/assign-teachers',
  api_generate_class_student_subject_report: 'school/classes/student-subjects',
  api_get_subjects_classes: 'school/classes/subjects-classes',

  // subject urls
  api_get_subjects: 'subjects',
  api_get_subject: (id: number) => `subjects/${id}`,
  api_add_subject: 'subjects/create',
  api_update_subject: (id: number) => `subjects/${id}`,
  api_update_subject_sequence: 'subjects/sequence',
  api_get_subject_sequence: 'subjects/sequence',
  api_generate_student_list: 'subjects/student-list-report',
  api_generate_overall_subject_report: 'subjects/overall-report',
  api_set_subject_weightage: (id: number) => `subjects/${id}/set-weightage`,
  api_generate_student_subject_report: 'subjects/student-subject-report',
  api_lock_selected_outline: 'subjects/lock-outline',
  api_unlock_selected_outline: 'subjects/unlock-outline',
  api_get_previous_subjects: 'subjects/previous-subjects',
  api_get_subject_exam: 'subjects/subject-exams',
  api_assign_subject_teachers: 'subjects/assign-teachers',
  api_get_subjects_subsections: 'subjects/subsection',
  api_add_subject_subsection: 'subjects/subsection/create',
  api_update_subject_subsection: (id: number) => `subjects/subsection/${id}`,
  api_get_subject_subsection: (id: number) => `subjects/subsection/${id}`,
  api_delete_subject_subsection: (id: number) => `subjects/subsection/${id}`,
  api_delete_many_subject_subsections: 'subjects/subsection/delete-many',
  api_get_exclude_subsections: (id: number) => `subjects/${id}/excluded-subsections`,
  api_update_exclude_subsection: 'subjects/save-excluded-subsections',
  api_copy_subsection: 'subjects/copy-subsection',
  api_get_syllabus_subjects: 'subjects/syllabus-subjects',
  api_reset_subject_sequence: 'subjects/reset-sequence',

  // activity urls
  api_get_activities: 'activities',

  //dataa-export
  api_save_data_export_request: 'data-export/process-export',

  // level urls
  api_get_levels: 'school/levels',
  api_get_levels_for_timetable: 'school/levels/levels-for-timetable',
  api_get_level: (id: number) => `school/levels/${id}`,
  api_view_level: (id: number) => `school/levels/view/${id}`,
  api_update_level: (id: number) => `school/levels/${id}`,
  api_delete_level: (id: number) => `school/levels/${id}`,
  api_get_active_branches: 'school/branch/active',
  api_get_all_branches: 'school/branch',
  api_add_branch: 'school/branch/add',
  api_view_branch: (id: number) => `school/branch/view/${id}`,
  api_update_branch: (id: number) => `school/branch/edit/${id}`,
  api_delete_branch_file: (id: number) => `school/branch/delete-logo-file/${id}`,
  api_delete_branch_banner_file: (id: number) => `school/branch/delete-banner-file/${id}`,

  // staff role urls
  api_get_staff_roles: 'school/staff-roles',
  api_create_staff_role: 'school/staff-roles/create',
  api_update_staff_role: (id: number) => `school/staff-roles/${id}/update`,
  api_get_staff_role: (id: number) => `school/staff-roles/${id}`,
  api_delete_staff_role: (id: number) => `school/staff-roles/${id}`,
  api_bulk_delete_staff_roles: 'school/staff-roles/delete-many',
  api_staff_role_permission_report: 'school/staff-roles/permission-report',
  api_bulk_delete: 'bulk-delete',
  api_assign_permissions: (id: number) => `school/staff-roles/${id}/assign-permissions`,
  api_get_assign_permissions: (id: number) => `school/staff-roles/${id}/assign-permissions`,
  api_assign_levels: (id: number) => `school/staff-roles/${id}/assign-levels`,
  api_get_assign_levels: (id: number) => `school/staff-roles/${id}/assign-levels`,
  api_assign_departments: (id: number) => `school/staff-roles/${id}/assign-departments`,
  api_get_assign_departments: (id: number) => `school/staff-roles/${id}/assign-departments`,

  // Digital Request Module urls
  api_get_digital_requests: 'school/digital-requests',
  api_get_digital_request: (id: number) => `school/digital-requests/${id}`,
  api_update_digital_request: (id: number) => `school/digital-requests/${id}`,
  api_delete_digital_request: (id: number) => `school/digital-requests/${id}`,
  api_export_digital_requests_excel: 'school/digital-requests/excel',

  api_add_level: 'school/levels/create',
  api_edit_level: (id: string) => `school/levels/edit/${id}`,
  // Resource Module urls
  api_get_resources: 'school/resources',
  api_get_resource: (id: number) => `school/resources/${id}`,
  api_add_resource: 'school/resources/create',
  api_update_resource: (id: number) => `school/resources/${id}`,
  api_delete_resource: (id: number) => `school/resources/${id}`,
  api_get_resource_signed_upload_url: 'school/resources/signed-upload-url',
  api_confirm_resource_file_upload: 'school/resources/confirm-file-upload',
  api_delete_resource_file: (resourceId: number, fileId: number) =>
    `school/resources/${resourceId}/files/${fileId}`,
  // Application Feedback Module urls
  api_application_feedback_status: 'school/application-feedback/status',
  api_application_feedback_submit: 'school/application-feedback',

  // Inquiry Module urls
  api_get_inquiries: 'inquiry',
  api_get_inquiry: (id: number) => `inquiry/${id}`,
  api_update_inquiry_status: (id: number) => `inquiry/${id}`,
  api_send_inquiry_message: 'inquiry/send-message',
  api_create_inquiry: 'inquiry/add',
  api_get_inquiry_types: 'inquiry/inquiry-types',
  api_delete_inquiry: (id: number) => `inquiry/${id}`,
  api_delete_many_inquiries: 'inquiry/delete-many',

  // Inquiry Setting Module urls
  api_get_inquiry_email_setting: (id: number) => `inquiry/inquiry-setting/${id}`,
  api_update_inquiry_email_setting: (id: number) => `inquiry/inquiry-setting/${id}`,

  api_get_inquiry_status_setting: 'inquiry/inquiry-setting',
  api_create_inquiry_status_setting: 'inquiry/inquiry-setting/create-status',
  api_update_inquiry_status_setting: (id: number) => `inquiry/inquiry-setting/update-status/${id}`,
  api_delete_inquiry_status_setting: (id: number) => `inquiry/inquiry-setting/delete-status/${id}`,

  // Module name urls
  api_get_module_names: 'school/module-names',

  // Tags Module urls
  api_get_tags: 'school/tags',
  api_get_tag: (id: number) => `school/tags/${id}`,
  api_add_tag: 'school/tags/create',
  api_update_tag: (id: number) => `school/tags/${id}`,
  api_delete_tag: (id: number) => `school/tags/${id}`,

  // Tags Category urls
  api_get_tags_categories: 'school/tag-categories',
  api_get_tags_category: (id: number) => `school/tag-categories/${id}`,
  api_add_tags_category: 'school/tag-categories/create',
  api_update_tags_category: (id: number) => `school/tag-categories/${id}`,
  api_delete_tags_category: (id: number) => `school/tag-categories/${id}`,

  api_load_custom_names_data: 'school/customNames',
  api_update_custom_names_data: 'school/customNames/update-custom-names',
  api_load_custom_names_mappings: 'school/customNames/get-mappings',
  api_reports_test: 'reports/test',

  api_get_student_dropout_pdf: 'school/students/dropout-pdf',
  api_get_month_wise_student_dropout_pdf: 'school/students/month-wise-dropout-pdf',

  // Attendance urls
  api_biometric_attendance: `attendance`,
  // Bulk Upload url
  api_bulk_upload: 'bulk-upload',
  api_track_progress_bar: 'bulk-upload/progress',
  api_logs_record: (id: number) => `bulk-upload/logs/${id}`,
  api_onboarding_ai_allocation: 'onboarding/ai-allocation',
  api_onboarding_extract_teachers: 'onboarding/extract-teachers',
  /** Reads the Teachers file again in the background into Students / Allocation drafts. */
  api_onboarding_prefill: 'onboarding/prefill',
  api_onboarding_seed_sample_data: 'onboarding/seed-sample-data',
  api_onboarding_data: 'onboarding/resume-data',
  api_onboarding_complete: 'onboarding/complete',
  api_onboarding_lesson_planning_template: 'onboarding/lesson-planning-template',
  api_onboarding_students_template: 'onboarding/students-template',
  api_onboarding_track_events: 'onboarding/track-events',
  /** Teacher Allocation, server-side (AI servers only; 404 elsewhere). */
  api_onboarding_allocation: 'onboarding/allocation',
  /** Save and finish later: merges the wizard keys into the admin's preferences (all servers). */
  api_onboarding_save_progress: 'onboarding/save-progress',
  api_timetable_countries: 'timetable/countries',
  api_timetable_curricula: 'timetable/curricula',
  api_timetable_prefill: 'timetable/prefill',
  api_attendance_mark_attendance: `attendance/mark`,
  api_attendance_unmark_attendance: `attendance/unmark`,
  api_attendance_checkout_details: `attendance/checkout-details`,
  api_attendance_update_attendance: `attendance/update`,
  api_attendance_settings_by_level: `attendance-setting/level-id`,
  api_attendance_settings_by_branch: `attendance-setting/branch-id`,
  api_get_attendance_setting: `attendance-setting/`,
  api_update_attendance_setting: `attendance-setting/update`,
  api_attendance_add_remarks: `attendance/remarks`,
  api_attendance_generate_individual_attendance_report: `attendance/generate-teacher-staff-individual-attendance-report`,
  api_attendance_generate_combine_attendance_report: `attendance/generate-teacher-staff-combine-attendance-report`,
  api_attendance_generate_individual_monthly_attendance_report: `attendance/generate-monthwise-individual-attendance-report-excel`,
  api_attendance_generate_combine_monthly_attendance_report: `attendance/generate-monthwise-combine-attendance-report-excel`,
  api_attendance_generate_teacher_subject_individual_attendance_report: `attendance/generate-teacher-subject-individual-report`,
  api_attendance_generate_teacher_subject_combine_attendance_report: `attendance/generate-teacher-subject-combine-report`,
  api_attendance_generate_teacher_subject_roster_attendance_report: `attendance/generate-teacher-subject-roster-report`,
  api_attendance_generate_student_subject_combine_attendance_report: `attendance/generate-student-subject-combine-report`,
  api_attendance_generate_student_subject_monthly_attendance_report: `attendance/generate-student-subject-monthly-report`,
  api_attendance_setting_create: `attendance-setting/create`,
  api_attendance_generate_student_subject_individual_attendance_report: `attendance/generate-student-subject-individual-report`,
  api_attendance_generate_student_individual_attendance_report: `attendance/generate-student-individual-attendance-report`,
  api_attendance_generate_student_combine_attendance_report: `attendance/generate-student-combine-attendance-report`,
  api_attendance_send_warning: `attendance/send-warning`,
  api_attendance_generate_student_classwise_summary_report: `attendance/generate-student-classwise-summary-report`,
  api_attendance_generate_student_subjectwise_summary_report: `attendance/generate-student-subjectwise-summary-report`,
  api_attendance_generate_student_monthwise_report: `attendance/generate-student-monthwise-report`,
  api_attendance_generate_student_subject_monthly_report: `attendance/generate-student-subject-monthly-report`,
  api_attendance_generate_student_subject_datewise_detailed_report: `attendance/generate-student-subject-datewise-detailed-report`,
  api_get_attendance_remarks: `attendance-remarks/`,
  api_add_attendance_remarks: `attendance-remarks/add`,
  api_attendance_remarks_get_by_type: `attendance-remarks/get-by-type`,
  api_delete_attendance_remarks: (id: number) => `attendance-remarks/${id}`,

  api_get_user_custom_attendance_schedule: `attendance-custom-schedule/`,
  api_get_one_user_custom_attendance_schedule: (id: number) => `attendance-custom-schedule/${id}`,
  api_add_user_custom_attendance_schedule: `attendance-custom-schedule/create`,
  api_update_user_custom_attendance_schedule: (id: number) => `attendance-custom-schedule/${id}`,
  api_delete_user_custom_attendance_schedule: (id: number) => `attendance-custom-schedule/${id}`,
  api_delete_all_user_custom_attendance_schedule: `attendance-custom-schedule/all`,
  api_add_multiple_user_custom_attendance_schedules: `attendance-custom-schedule/bulk-create`,

  api_get_StdMonthAttendanceById: 'attendance/get-students-month-wise-attendance',
  api_get_TodayAttendanceById: 'attendance/today-attendance',

  api_get_admission_fee_voucher_dates: 'school/admission-fee-voucher-dates',
  api_get_admission_fee_voucher_date: (id: number) => `school/admission-fee-voucher-dates/${id}`,
  api_add_admission_fee_voucher_date: 'school/admission-fee-voucher-dates',
  api_update_admission_fee_voucher_date: (id: number) => `school/admission-fee-voucher-dates/${id}`,
  api_delete_admission_fee_voucher_date: (id: number) => `school/admission-fee-voucher-dates/${id}`,
  api_delete_many_admission_fee_voucher_dates: 'school/admission-fee-voucher-dates/delete-many',
  api_get_std_month_attendance_by_id: 'attendance/get-students-month-wise-attendance',
  api_get_today_attendance_by_id: 'attendance/get-today-attendance',

  api_add_grade: 'school/grades/create',
  api_get_grades: 'school/grades',
  api_get_grade: (id: number) => `school/grades/${id}`,
  api_delete_grade: (id: number) => `school/grades/${id}`,
  api_inactivate_grade: (id: number) => `school/grades/${id}/inactivate`,
  api_update_grade: (id: number) => `school/grades/${id}`,
  api_delete_many_grades: 'school/grades/delete-many',
  api_get_subject_grades: `school/grades/subject-grades`,

  api_add_section: 'school/sections/create',
  api_get_sections: 'school/sections',
  api_get_section: (id: number) => `school/sections/${id}`,
  api_delete_section: (id: number) => `school/sections/${id}`,
  api_update_section: (id: number) => `school/sections/${id}`,
  api_delete_many_sections: 'school/sections/delete-many',

  //exam urls
  api_get_exams: 'exam/school',
  // student/parent scoped list (node Exam.index): own published exams + obtained marks
  api_get_my_exams: 'exam',
  api_get_exam: (id: number | string) => `exam/${id}`,
  /* The legacy records a view from its FRONT controller when a student or
     parent opens an exam (`controllers/front/ExamController.php:40`,
     `Controller::recordItemView`), which is what the staff "Views" list
     counts. */
  api_record_item_view: 'user-delivered-items/create',
  api_create_exam: 'exam/create',
  api_update_exam: (id: number | string) => `exam/${id}`,
  api_delete_exam: (id: number | string) => `exam/${id}`,
  api_delete_many_exams: 'exam/delete-many',
  api_get_exam_labels: 'exam/labels',
  api_exam_setup_status: 'exam/setup-status',

  // exam mark entry
  api_get_exam_results: (id: number | string) => `exam/${id}/results`,
  api_update_exam_result: 'exam/update-result',
  api_assign_exam_marks_to_all: 'exam/bulk-assign-marks',
  api_get_exam_grace_marks: 'exam/grace-marks',
  api_save_exam_grace_marks: 'exam/grace-marks/save',
  api_get_exam_type_weightages: 'exam/exam-type-weightages',
  api_save_exam_type_weightages: 'exam/exam-type-weightages/save',

  // assessment groups (exam.md 4)
  api_get_assessment_groups: 'tests/assessment-group',
  api_get_assessment_group: (id: number) => `tests/assessment-group/${id}`,
  api_create_assessment_group: 'tests/assessment-group/create',
  api_update_assessment_group: (id: number) => `tests/assessment-group/${id}`,
  api_delete_assessment_group: (id: number) => `tests/assessment-group/${id}`,

  // previous academic records (exam.md area 20)
  api_academic_records: 'academic-records',
  api_academic_record_options: 'academic-records/options',
  api_create_academic_record: 'academic-records/create',
  api_academic_record: (id: number) => `academic-records/${id}`,

  // report card results, publish + dispatch
  api_get_report_card_results: 'reportCardResult',
  api_get_report_card_result_students: 'reportCardResult/students',
  api_publish_report_cards: 'reportCardResult/publish',
  api_send_report_card_notification: 'reportCardResult/send-notification',
  api_send_report_card_mail: 'reportCardResult/send-mail',
  // Generation (exam.md 1.5c.4 stage 1). `generate` runs the chunk loop and
  // answers with the run summary; `generate/progress` is polled alongside it
  // against the same job_id.
  api_generate_report_cards: 'reportCardResult/generate',
  api_report_card_generation_progress: 'reportCardResult/generate/progress',
  api_regenerate_report_cards: 'reportCardResult/regenerate',
  api_update_report_card_result: (id: number | string) => `reportCardResult/${id}`,
  api_delete_report_card_result: (id: number | string) => `reportCardResult/${id}`,

  // report card settings hierarchy
  api_get_report_card_settings: 'grade-and-labelwise-exam-reportcard-setting/settings',
  api_save_report_card_settings: 'grade-and-labelwise-exam-reportcard-setting/settings/save',
  api_get_report_card_extra_parameters: 'report-card-extra-parameters',
  api_save_report_card_extra_parameters: 'report-card-extra-parameters/save',
  api_delete_report_card_extra_parameter: (id: number | string) =>
    `report-card-extra-parameters/${id}`,

  // skill reports
  api_get_skill_reports: 'skill-reports',
  api_get_skill_report_sheet: 'skill-reports/sheet',
  api_save_skill_report_sheet: 'skill-reports/sheet/save',

  // PDF reports suite - ported tabs of school/reports/pdfreports (exam.md 8.1)
  api_get_exam_report_section_wise: 'exam-reports/section-wise',
  api_get_exam_report_accumulated_sheet: 'exam-reports/accumulated-sheet',
  api_get_exam_report_combined_test: 'exam-reports/combined-test-report',
  api_get_exam_report_gpa_analysis: 'exam-reports/gpa-analysis',
  api_get_exam_report_combined_weightage: 'exam-reports/combined-weightage',
  api_get_exam_report_marksheet: 'exam-reports/marksheet',
  api_send_exam_report_marksheet: 'exam-reports/marksheet/notify',
  api_get_exam_report_cumulative_section_wise: 'exam-reports/cumulative-section-wise',
  api_get_exam_report_analysis_student_wise: 'exam-reports/analysis-student-wise',
  api_get_exam_report_analysis_section_wise: 'exam-reports/analysis-section-wise',
  api_get_exam_report_grade_analysis: 'exam-reports/grade-analysis',
  api_get_exam_report_test_reports: 'exam-reports/test-reports',
  api_get_exam_report_homework_reports: 'exam-reports/homework-reports',
  api_get_exam_report_grade_analysis_students: 'exam-reports/grade-analysis-students',

  // report-card remarks + per-student extra parameter values (exam.md 9, 7.3)
  api_get_exam_remarks_sheet: 'exam-remarks/sheet',
  api_save_exam_remarks_overall: 'exam-remarks/overall',
  api_save_exam_remarks_subject: 'exam-remarks/subject',
  api_save_exam_remarks_subsection: 'exam-remarks/subsection',
  api_save_exam_remarks_extra_parameters: 'exam-remarks/extra-parameters',

  // post-report dynamic variable values
  api_get_student_variable_values: 'dynamic-variables/student-values',
  api_save_student_variable_values: 'dynamic-variables/student-values/save',
  api_save_all_student_variable_values: 'dynamic-variables/student-values/save-all',

  // Exam Schedule Settings
  api_get_exam_schedule_setting: 'exam-schedule-setting/index',
  api_delete_exam_schedule_setting: 'exam-schedule-setting',
  api_delete_many_exam_schedule_settings: 'exam-schedule-setting/delete-many',
  api_save_exam_schedule_setting: 'exam-schedule-setting/store',
  api_generate_individual_schedule: 'exam-schedule-setting/generate-individual',
  api_generate_class_schedule: 'exam-schedule-setting/generate-class',

  //Performance Reports
  api_get_performance_report_chart_data: 'school/performance-reports/chart-data',
  api_get_performance_report_filters_data: 'school/performance-reports/filters-data',
  api_get_performance_report_settings: 'school/performance-reports/settings',
  api_update_performance_report_settings: 'school/performance-reports/settings',
  api_get_performance_report_signature_upload_url:
    'school/performance-reports/settings/signature-upload-url',
  api_get_comprehensive_report_filters: 'school/oa-level-reports/comprehensive-reports/filters',
  api_generate_comprehensive_report: 'school/oa-level-reports/comprehensive-reports/generate',
  api_get_caie_statistics_filters: 'school/oa-level-reports/caie-statistics/filters',
  api_generate_caie_statistics: 'school/oa-level-reports/caie-statistics/generate',
  api_get_exam_performance_report: 'exam/performance-report',
  api_generate_academic_performance_report: 'exam/academic-performance-report',
  api_get_exam_reportcard_word_templates: 'exam-reportcard-word-templates',
  api_create_exam_reportcard_word_template: 'exam-reportcard-word-templates/create',
  api_get_exam_reportcard_word_template: (id: number) => `exam-reportcard-word-templates/${id}`,
  api_update_exam_reportcard_word_template: (id: number) => `exam-reportcard-word-templates/${id}`,
  api_delete_exam_reportcard_word_template: (id: number) => `exam-reportcard-word-templates/${id}`,
  api_get_dynamic_variables: 'dynamic-variables',
  api_get_dynamic_variable_values: 'dynamic-variables/values',
  api_get_word_template_form_settings: 'exam-reportcard-word-templates/form-settings',

  //Accounts
  api_add_account_type: 'school/account-types/create',
  api_delete_account_type: (id: number) => `school/account-types/${id}`,
  api_update_account_type: (id: number) => `school/account-types/${id}`,
  api_delete_many_account_type: 'school/account-types/delete-many',

  //term urls
  api_get_terms: 'terms',

  //duration and versions urls
  api_add_new_duration: 'timetable/add-new-duration',
  api_update_duration: (id: number) => `timetable/${id}/update-duration`,
  api_get_all_durations: 'timetable/get-all-durations',
  api_get_all_versions: 'timetable/get-all-versions',
  api_get_recent_timetable_versions: 'timetable/recent-versions',
  api_activate_version: 'timetable/activate-version',
  api_update_version_name: 'timetable/update-version-name',
  api_delete_timetable_version: (id: number) => `timetable/${id}/delete-version`,
  api_delete_duration: (id: number) => `timetable/${id}/delete-duration`,
  api_get_work_break_down_by_level_id: `timetable/teacher-workload`,
  api_update_work_break_down_frequency: (id: number) => `timetable/${id}/update-subject-workload`,
  api_bulk_update_workload: `timetable/bulk-update-workload`,

  //Tickting Functonality
  api_get_hubspot_tickets: 'school/hubspot',
  api_get_hubspot_ticket: (id: number | string) => `school/hubspot/${id}`,
  api_create_hubspot_ticket: 'school/hubspot/',
  api_update_hubspot_ticket: (id: number | string) => `school/hubspot/${id}`,
  api_delete_hubspot_ticket: (id: number | string) => `school/support-tickets/${id}`,
  api_reply_hubspot_ticket: (id: number | string) => `school/hubspot/${id}/reply`,

  //Timetable
  api_get_access_token: `ai-credits/ai-credits-login`,
  api_get_user_statistics: `ai-credits/available-services`,
  api_get_timetable_categories: `timetable/categories`,
  api_get_timetable_subcategories: `timetable/sub-categories`,
  api_update_timetable: `timetable/update-timetable`,
  api_get_timetable_constraints: `timetable/constraints`,
  api_get_timetable_subcategory_by_id: (id: number) => `timetable/${id}/sub-categories`,
  api_add_constraint: `timetable/constraint`,
  api_get_all_constraints: `timetable/constraints`,
  api_delete_constraint: (id: number) => `timetable/${id}/constraint`,
  api_update_constraint: (id: number) => `timetable/${id}/constraint`,
  api_update_constraint_list: `timetable/batch-update-constraints`,
  api_get_timetable: `timetable`,
  api_get_timetable_list_data: (id: number) => `timetable/${id}/list-data`,
  api_request_timetable: `timetable/request`,
  api_delete_timetable: `timetable/delete`,
  api_get_timetable_report: `timetable/report`,
  api_timetable_report_generation_pdf: 'timetable/timetable-report-generation-pdf',
  api_generate_prompt: `timetable/generate-prompt`,
  api_validate_timetable: `timetable/validate-timetable-v2`,
  api_validate_teacher_availability: `timetable/validate-teacher-availability`,
  api_timetable_warning: `timetable/multilevel-teacher-subjects`,
  api_validate_concurrent_subjects: `timetable/validate-concurrent-subjects`,
  api_timetable_create_class_venues: `timetable/create-class-venues`,
  api_validate_timetable_capacity: `timetable/validate-timetable-capacity`,
  api_validate_subject_pairs_concurrent: `timetable/validate-subject-pairs-concurrent`,
  api_get_timetable_status: 'timetable/get-status',
  api_get_timetable_student_subjects: (level: number) => `timetable/${level}/student-subjects`,
  api_socket_message_log: 'timetable/socket-message-log',
  api_deactivate_version: (version_id: number) => `timetable/${version_id}/deactivate-version`,

  api_get_free_teachers: 'timetable/free-teachers',
  api_get_free_venues: 'timetable/free-venues',
  api_diagnose_timetable_failures: 'timetable/diagnose-failures',
  api_calculate_timetable_tokens: 'timetable/token-calculation',
  api_check_all_subjects_enrollment: 'timetable/check-all-subjects-enrollment',
  api_validate_class_subject_load: 'timetable/validate-class-subject-load',
  api_timetable_log_export: 'timetable/log-export',
  api_timetable_track_event: 'timetable/track-event',

  // College Counselling APIs
  api_college_counselling_portfolios: 'college-counselling',
  api_college_counselling_my_portfolio: 'college-counselling/my-portfolio',
  api_college_counselling_my_portfolios: 'college-counselling/my-portfolios',
  api_college_counselling_start: 'college-counselling/start',
  api_college_counselling_stats: 'college-counselling/stats',
  api_college_counselling_teachers: 'college-counselling/teachers',
  api_college_counselling_teacher_requests: 'college-counselling/teacher-requests',
  api_college_counselling_submit: 'college-counselling/submit',
  api_college_counselling_save_section: 'college-counselling/section/save',
  api_college_counselling_save_academics: 'college-counselling/academics/save',
  api_college_counselling_save_destinations: 'college-counselling/destinations/save',
  api_college_counselling_document_types: 'college-counselling/document/types',
  api_college_counselling_save_document: 'college-counselling/document/save',
  api_college_counselling_delete_document: (id: string) => `college-counselling/document/${id}`,
  api_college_counselling_settings: 'college-counselling/settings',
  api_college_counselling_destinations: 'college-counselling/destination',
  api_college_counselling_create_destination: 'college-counselling/destination/create',
  api_college_counselling_destination: (id: string) => `college-counselling/destination/${id}`,
  api_college_counselling_portfolio: (id: string) => `college-counselling/${id}`,
  api_college_counselling_return_portfolio: (id: string) => `college-counselling/${id}/return`,
  api_college_counselling_portfolio_status: (id: string) => `college-counselling/${id}/status`,
  api_college_counselling_recommendation: (id: string) =>
    `college-counselling/${id}/recommendation`,
  api_college_counselling_recommendation_draft: (id: string) =>
    `college-counselling/${id}/recommendation-draft`,
  api_college_counselling_recommendation_letter: (id: string) =>
    `college-counselling/${id}/recommendation-letter`,
  api_college_counselling_application_pdf: (id: string) =>
    `college-counselling/${id}/application-pdf`,
  api_college_counselling_send_recommendation: (id: string) =>
    `college-counselling/${id}/send-recommendation`,
  api_college_counselling_reject_recommendation: (id: string) =>
    `college-counselling/${id}/reject-recommendation`,
  // Reached without a session — the token is the credential.
  api_college_counselling_external_recommendation: (token: string) =>
    `college-counselling/external-recommendation/${token}`,

  // CSV Import APIs
  api_csv_import_table_schemas: 'csv-import/table-schemas',
  api_csv_import_schema: 'csv-import/schema',
  api_csv_import_upload: 'csv-import/upload',
  api_csv_import_confirm: 'csv-import/confirm',
  api_csv_import_bulk: 'csv-import/bulk-import',
  api_csv_import_school_systems: 'csv-import/school-systems',
  api_csv_import_school_systems_details: 'csv-import/school-systems-details',
  api_csv_import_download_template: 'csv-import/download-template',
  api_csv_import_create_venues: 'class-rooms/create-venues',
  // Data upload: any file -> our template (AI servers only; 404 elsewhere)
  api_data_upload_use_cases: 'data-upload/use-cases',
  api_data_upload_convert: 'data-upload/convert',
  // Chunked upload: nginx refuses bodies over 1 MB, so every file goes in 512 KB pieces.
  api_data_upload_uploads: 'data-upload/uploads',
  api_data_upload_upload: (uploadId: string) => `data-upload/uploads/${uploadId}`,
  api_data_upload_chunk: (uploadId: string, index: number) =>
    `data-upload/uploads/${uploadId}/chunks/${index}`,
  // What this school calls its own subjects: the confirmed mappings, read and written.
  api_data_upload_subject_aliases: 'data-upload/subject-aliases',
  api_data_upload_drafts: 'data-upload/drafts',
  api_data_upload_draft: (draftId: string) => `data-upload/drafts/${draftId}`,
  api_data_upload_draft_job: (draftId: string) => `data-upload/drafts/${draftId}/job`,
  api_data_upload_draft_template: (draftId: string) => `data-upload/drafts/${draftId}/template`,
  api_data_upload_draft_answers: (draftId: string) => `data-upload/drafts/${draftId}/answers`,
  api_data_upload_draft_applied: (draftId: string) => `data-upload/drafts/${draftId}/applied`,
  api_get_client_secrets: 'school/client-secrets',
  api_delete_client_secret: (id: number) => `school/client-secrets/${id}`,
  api_create_client_secret: `school/client-secrets/create`,
  api_show_client_secret: (id: number) => `school/client-secrets/${id}`,
  api_update_client_secret: (id: number) => `school/client-secrets/update/${id}`,
  // School integrations (My Profile > Integrations)
  api_integration_kenzer_roots: 'school/integrations/kenzer-roots',
  api_integration_kenzer_roots_generate_key: 'school/integrations/kenzer-roots/generate-key',
  api_integration_kenzer_roots_config: 'school/integrations/kenzer-roots/config',
  api_integration_kenzer_roots_launch: 'school/integrations/kenzer-roots/sso/launch',

  api_index_monthly_audit_report: `monthly-audit-summary/`,
  api_store_monthly_audit_report: `monthly-audit-summary/create`,
  api_delete_all_monthly_audit_report: `monthly-audit-summary/`,

  // actm account setting
  api_get_actm_account_setting_by_branch_id: (branch_id: number) =>
    `school/actm-account-setting/${branch_id}`,

  // Designer API
  api_designer_create: 'designer/create',
  api_designer_update: 'designer',
  api_designer_delete: 'designer',
  api_designer_list: 'designer',
  api_designer_detail: 'designer',
  api_designer_versions: 'designer',
  api_designer_generate_id_cards: 'designer/generate-id-cards',
  api_designer_generate_faculty_id_cards: 'designer/generate-faculty-id-cards',
  api_designer_generate_certificates: 'designer/generate-certificates',
  api_designer_generate: 'designer/generate',
  api_designer_generate_report_cards: 'designer/generate-report-cards',
  api_designer_preview_report_card: 'designer/preview-report-card',
  api_designer_pdf_preview: 'designer/pdf-preview',
  api_designer_library_folder: 'designer/library/folder',
  api_designer_library_delete: 'designer/library',
  api_designer_library_import: 'designer/library/import',
  api_designer_library_tree: 'designer/library/tree',
  api_designer_library_component: 'designer/library/component',
  api_designer_library_update: 'designer/library',
}
export const base_url = constants.api_base_url + constants.version

export const M_LAYOUT = 'm_layout'

export const CERTIFICATE_TYPES = {
  STUDENT: 0,
  HR: 1,
  CCA_CERTIFICATE: 2,
}

export const MODULES = [
  {name: 'Lectures', value: 'lecture'},
  {name: 'Homework', value: 'homework'},
  {name: 'News', value: 'news'},
  //{ name: 'Blog'},
  {name: 'Tests', value: 'test'},
  {name: 'Exams', value: 'exam'},
  //{name: 'Reports'},
  //{name: 'Attendance'},
  //{name: 'Activities'},
  {name: 'Events', value: 'event'},
  {name: 'Fee', value: 'fee'},
]

export const SECRET_KEY = {
  android: 'ePW7KwPpBVPH6QVmbFS',
  ios: '53aNQRfhMVIoLSfiM5Q',
  web: 'rr0y3T5WjEKG3OrU2NN',
}

export const RECAPTCHA = {
  siteKey: '6LcYbqoeAAAAAGFyKacGyAZbTtPnrritbVkbVrMo',
  baseUrl: 'https://api.ilmversity.net',
}

export const MAX_FILE_SIZE = {
  name: '10 MB',
  value: 10485760,
}
export const CONCURRENT_FILE_UPLOADS = 5
export const ALLOWED_EXTS = [
  'pdf',
  'doc',
  'docx',
  'txt',
  'rtf',
  'xls',
  'xlsx',
  'mp3',
  'jpeg',
  'jpg',
  'png',
]

export const ALLOWED_EXTS_CLASS = 'pdf, doc, docx, txt, rtf, xls, xlsx, mp3, jpeg, jpg, png'
export const ALLOWED_EXTS_CLASS_TEST = 'pdf, doc, docx'

export const GRADE_STATUS = {
  ACTIVE: 1,
  INACTIVE: 0,
}

export const GENERAL = {
  ACTIVE: 1,
  INACTIVE: 0,
}

export const ACCESS_TOKEN_KEY = 'accessToken'
export const TENANT_KEY = 'tenant'
export const LOGIN_URL_KEY = 'loginUrl'
export const USER_KEY = 'user'
export const USER_TYPE_KEY = 'userType'
export const SELECTED_CHILD_KEY = 'selectedChild'
export const APP_SETTINGS_KEY = 'appSettings'
export const BACKGROUND_IMAGE = 'backgroundImage'
export const NA = 'N/A'
export const IMAGE = 'image'
export const VIDEO = 'video'
export const WEBVIEW_PARAM = 'mlayout=false'

// Overbooked Teachers Modal Constants
export const STUDENT_TABLE_COLUMNS = 4

export const BASE_HOSTS = [
  'ilmversetech.com',
  'ilmversity.com',
  'ilmversity.online',
  'ilmversity.dev',
  'ilmversity.click',
  'ilmversity.ai',
  'da1timetable.ai',
  'da1timetable.info',
]

const defaultTenant = import.meta.env.VITE_APP_DEFAULT_TENANT || 'myschool'
const hostname = window.location.hostname.replace('www.', '')
const tenantName = BASE_HOSTS.some((baseHost) => hostname.includes(baseHost))
  ? hostname.split('.')[0]
  : null

export const DEFAULT_TENANT_VALUE =
  import.meta.env.VITE_APP_ENV === 'local' || !tenantName ? defaultTenant : tenantName

export const TENANT_CUSTOM_DOMAINS = {
  aligarh: ['parents.aligarhonline.edu.pk'],
  alsuffah: ['alsuffahacademy.com.pk'],
  ccphs: ['portal.ccphs.edu.pk'],
  eureka: ['eureka-pingu.eurekaglobal.org'],
  gsc: ['portal.shalimarcollege.edu.pk'],
  iconcollege: ['icc.ilmversity.net', 'iconcollege.edu.pk'],
  leadership: ['slims.leadershipschool.pk'],
  lgs: ['1view.lahoregrammar.school'],
  lyceum: ['portal.lyceumschool.edu.pk'],
  mphs: ['mohsinpublichighschool.edu.pk'],
  psi: ['portal.psi.edu.pk'],
  pss: ['portal.pss.edu.pk'],
  rayden: ['portal.thetitancollege.com', 'portal.titan.edu.pk', 'admissions.titan.edu.pk'],
  risc: ['miles.rootsinternational.edu.pk'],
  rivy: ['lms.ivyacademicnetworks.com'],
  sis: ['myspace.scarsdale.edu.pk'],
  smcs: ['portal.st-michaels.edu.pk'],
  smhss: ['sindhmodelhighschool.edu.pk'],
  theoxford: ['oss.edu.pk'],
  tres: ['aims.tres.edu.pk'],
  twpsc: ['lms.twpsc.edu.pk'],
  whales: ['portal.whalescollege.com'],
  wlgs: ['portal.worldlearninginternational.org'],
  zicas: ['zicasschool.com'],
}

export const TENANT_CUSTOM_IMAGES: {
  [key: string]: {background_image?: string; big_logo?: string; small_logo?: string}
} = {
  lgs: {
    background_image: toAbsoluteUrl('/media/background/lgs_auth_bg_blue.png'),
    big_logo: toAbsoluteUrl('/media/logos/lgs_logo_big_blue.png'),
    small_logo: toAbsoluteUrl('/media/logos/lgs_logo_small_blue.png'),
  },
  risc: {
    background_image:
      'https://ilm-root-uploads.s3.eu-central-1.amazonaws.com/upload/domain/risc_ilmversity_net/baground/1660111418186_1.jpeg',
    big_logo:
      'https://ilmversity-uploads-bkp.s3.eu-central-1.amazonaws.com/upload/domain/risc.ilmversity.net/logo/big/1722939582590_289298.png',
    small_logo:
      'https://ilmversity-uploads-bkp.s3.eu-central-1.amazonaws.com/upload/domain/risc.ilmversity.net/logo/small/1722939514212_289298.png',
  },
}

/** Legacy iframe hosts per tenant, primary first — one per domain in TENANT_CUSTOM_DOMAINS. */
export const TENANT_CUSTOM_IFRAME_URL: {[key: string]: string[]} = {
  lgs: ['1view2.lahoregrammar.school'],
  risc: ['miles2.rootsinternational.edu.pk'],
  // TODO add 'portal2.titan.edu.pk' once its DNS + cert are live
  rayden: ['portal2.thetitancollege.com'],
  tres: ['aims2.tres.edu.pk'],
  rivy: ['lms2.ivyacademicnetworks.com'],
  lyceum: ['portal2.lyceumschool.edu.pk'],
}

export const DEVICE_LIMIT_FULL_MESSAGE =
  'You are already logged in from another device. Now in order to continue with this device we are going to log you out from other device. Thanks.'

export const VENDOR_STATUS = {
  PENDING: 0,
  ACTIVE: 1,
  BLOCKED: 2,
}

export const DIGITAL_REQUEST_STATUS = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2,
  COMPLETE: 3,
}

export const COLLEGE_COUNSELLING_STATUS = {
  DRAFT: 0,
  SUBMITTED: 1,
  REVIEWED: 2,
  CHANGES_REQUESTED: 3,
} as const

export const COLLEGE_COUNSELLING_RETURNED_STATUSES: number[] = [
  COLLEGE_COUNSELLING_STATUS.CHANGES_REQUESTED,
]

export const COLLEGE_COUNSELLING_VIEWABLE_STATUSES: number[] = [
  COLLEGE_COUNSELLING_STATUS.SUBMITTED,
  COLLEGE_COUNSELLING_STATUS.REVIEWED,
]

export const COLLEGE_COUNSELLING_STATUS_BADGES: Record<number, string> = {
  [COLLEGE_COUNSELLING_STATUS.DRAFT]: 'badge-light-secondary',
  [COLLEGE_COUNSELLING_STATUS.SUBMITTED]: 'badge-light-primary',
  [COLLEGE_COUNSELLING_STATUS.REVIEWED]: 'badge-light-success',
  [COLLEGE_COUNSELLING_STATUS.CHANGES_REQUESTED]: 'badge-light-danger',
}

export const COLLEGE_COUNSELLING_EDIT_SLOT = {
  NONE: 0,
  TEACHER1: 1,
  TEACHER2: 2,
  EXTERNAL: 3,
} as const

export type CollegeCounsellingSlotKey = 'teacher1' | 'teacher2' | 'external_teacher'

export const COLLEGE_COUNSELLING_EDITABLE_SLOTS: Record<number, CollegeCounsellingSlotKey[]> = {
  [COLLEGE_COUNSELLING_EDIT_SLOT.TEACHER1]: ['teacher1'],
  [COLLEGE_COUNSELLING_EDIT_SLOT.TEACHER2]: ['teacher2', 'external_teacher'],
  [COLLEGE_COUNSELLING_EDIT_SLOT.EXTERNAL]: ['teacher2', 'external_teacher'],
}

export type CollegeCounsellingSectionKey =
  | 'profile'
  | 'planning'
  | 'academics'
  | 'activities'
  | 'recommendations'
  | 'reflection'
  | 'documents'
  | 'consent'

export const COLLEGE_COUNSELLING_SECTIONS: {
  key: CollegeCounsellingSectionKey
  titleId: string
}[] = [
  {key: 'profile', titleId: 'COUNSELLING.SECTION.PROFILE'},
  {key: 'planning', titleId: 'COUNSELLING.SECTION.PLANNING'},
  {key: 'academics', titleId: 'COUNSELLING.SECTION.ACADEMICS'},
  {key: 'activities', titleId: 'COUNSELLING.SECTION.ACTIVITIES'},
  {key: 'recommendations', titleId: 'COUNSELLING.SECTION.RECOMMENDATIONS'},
  {key: 'reflection', titleId: 'COUNSELLING.SECTION.REFLECTION'},
  {key: 'documents', titleId: 'COUNSELLING.SECTION.DOCUMENTS'},
  {key: 'consent', titleId: 'COUNSELLING.SECTION.CONSENT'},
]

export const COLLEGE_COUNSELLING_CATEGORY_BADGES: Record<number, string> = {
  1: 'badge badge-light-danger',
  2: 'badge badge-light-warning',
  3: 'badge badge-light-info',
}

export const COLLEGE_COUNSELLING_NO_CATEGORY = 4

export const DIGITAL_REQUEST_TYPE = {
  CLASS_LEAVE: 0,
  ASSESSMENT_LEAVE: 1,
}

export const DIGITAL_REQUEST_OBJECT_TYPE = {
  SUBJECT_LEAVE: 0,
  EXAM_LEAVE: 1,
  TEST_LEAVE: 2,
  ASSIGNMENT_LEAVE: 3,
  CUSTOM_REQUEST: 4,
}

export const TOTAL_MARKS_TYPES = {
  APPLICABLE: 1,
  NOT_APPLICABLE: 0,
}

export const MODULE_PERMISSIONS = {
  MODULE_USER_MANAGER: 1,
  MODULE_SCHEDULE_MANAGER: 2,
  MODULE_ATTENDANCE_MANAGER: 3,
  MODULE_NEWS_MANAGER: 4,
  MODULE_CLASS_SUBJECT_MANAGER: 5,
  MODULE_HOMEWORK_MANAGER: 6,
  MODULE_TEST_MANAGER: 7,
  MODULE_EXAM_MANAGER: 8,
  MODULE_PERFORMANCE_REPORTS: 9,
  MODULE_EXTRA_CURRICULAR_ACTIVITIES: 10,
  MODULE_NOTIFICATION_MANAGER: 11,
  MODULE_BLOG_MANAGER: 12,
  MODULE_FINANCE_MANAGER: 13,
  MODULE_FEE_MANAGER: 14,
  MODULE_HR_MANAGER: 15,
  MODULE_LEVEL_MANAGER: 16,
  MODULE_INVENTORY_MANAGER: 17,
  FEE_COLLECTION_SUMMARY: 18,
  MODULE_QUIZ_SYSTEM: 19,
  MODULE_ATTENDANCE_SCHEDULE: 20,
  MODULE_ROYALTY_MANAGER: 21,
  FEE_SETTINGS: 22,
  SYLLABUS_MANAGER: 23,
  ACCOUNTS_MANAGER: 24,
  DEPARTMENT_MANAGER: 25,
  EXAM_SETTINGS_MANAGER: 26,
  WEBSITE_SETTINGS: 27,
  MODULE_STUDENT_ATTENDANCE: 28,
  MODULE_TEACHER_ATTENDANCE: 29,
  MODULE_ATTENDANCE_SETTINGS: 30,
  MODULE_TEST_TYPES: 31,
  ADD_EDIT_DISCOUNT: 32,
  HR_SETTINGS: 33,
  GENERATE_VOUCHERS: 34,
  FEE_PAYMENT: 35,
  CLEAR_PAYMENT: 36,
  PRINT_VOUCHERS: 37,
  SEND_VOUCHER_NOTIFICATION: 38,
  SEND_VOUCHER_SMS: 39,
  FEE_VOUCHER_EDIT: 40,
  FEE_VOUCHER_UPDATE_PARTICULAR: 41,
  FEE_VOUCHER_ADD_MISC_AMOUNT: 42,
  FEE_VOUCHER_ADD_ADVANCE_FEE: 43,
  FEE_VOUCHER_ADD_TAX: 44,
  FEE_VOUCHER_UPDATE_PARTICULAR_AMOUNT: 45,
  MODULE_VIDEO_LEC_MANAGER: 46,
  MODULE_TAG_MANAGER: 47,
  RESTRICT_STAFF_VIEW_TEACHER_DOCS: 48,
  RESTRICT_STAFF_VIEW_STAFF_DOCS: 49,
  FEE_SCHEDULE: 50,
  MODULE_VENDOR_MANAGER: 51,
  CAIE_RECHECKING: 52,
  MODULE_LIBRARY_MANAGER: 53,
  ADMISSION_FORM: 54,
  MODULE_REQUEST_MANAGER: 55,
  DATA_UPLOAD_MANAGER: 56,
  REPORTCARD_NOTIFICATION: 57,
  DOWNLOAD_ARCHIVE: 58,
  MODULE_ATTENDANCE_AMENDMENT_REQUEST: 59,
  MODULE_ATTENDANCE_AMENDMENT_REQUEST_APPROVE_REJECT: 60,
  ATTENDANCE_OFFICER: 61,
  REGISTRAR: 62,
  MODULE_DIGITAL_REQUEST_MANAGER: 63,
  RESOURCE_CENTER: 64,
  ACTIVITY_MANAGER: 65,
  RESET_PASSWORD: 66,
  ALLOCATE_TEACHERS: 67,
  SPECIAL_DISCOUNT_PARTICULARS_ONLY: 68,
  FEE_VOUCHER_UPDATE_PARTICULAR_AMOUNT_EXCEPT_HIDDEN: 69,
  FORM_MANAGER: 70,
  OBSERVATION_MANAGER: 71,
  FORM_QUESTION_MANAGER: 72,
  AI_TIMETABLE: 73,
  SYSTEM_REPORTS_JOBS_SUMMARY: 74,
  CLASS_SUBJECT_MANAGER_ALLOCATE_STUDENTS: 75,
  APR_REPORTS: 76,
  DESIGN_TOOL: 77,
  INQUIRY_MANAGER: 78,
  COLLEGE_COUNSELLING: 79,
}

export const PERMISSIONS = {
  PERMISSION_CREATE: 1,
  PERMISSION_UPDATE: 2,
  PERMISSION_DELETE: 3,
}

export const TABLES = {
  GENERAL_SETTINGS: 'general_settings',
  ID_CARD_SETTINGS: 'id_card_setting',
  STAFF_ID_CARD_SETTINGS: 'staff_id_card_settings',
  OUTLINE_SETTINGS: 'outline_settings',
  COMPREHANSIVE_SETTINGS: 'comprehansive_report_settings',
  PREDICTED_SETTINGS: 'predicted_grades_report_setting',
  EAR_SERVICES: 'ear_services',
}

export const FILE_TYPE = {
  CLASS_SUBJECT_TEACHER: 'class_subject_teacher',
  STUDENT_PARENT: 'student_parent',
  TAGS: 'tags',
  LABELS: 'labels',
  INVENTORY: 'inventory',
  STUDENT_HOMEWORK: 'student_homework',
  STUDENT_EXAM: 'student_exam',
  STUDENT_TEST: 'student_test',
  ANNUAL_CALENDAR: 'annual_calendar',
}

export const GENDER = {
  MALE: 0,
  FEMALE: 1,
}

export const ONBOARD_PROGRESS = {
  STEP_1: 33,
  STEP_2: 66,
  STEP_3: 99,
  LAST_STEP: 100,
}
export const ATTENDANCE_SETTING_TABLES = {
  ATTENDANCE_SETTING: 'attendance_setting',
}

export const CUSTOM_SELECT_ALL_VALUE = 'option_select_all_filtered'
export const CUSTOM_DESELECT_ALL_VALUE = 'option_deselect_all_filtered'

export const SEND_ATTENDANCE_SMS_FOR = [
  {label: 'ATTENDANCE_SETTING_BASIC_SETTINGS.ATTENDANCE_STATUS.SMS.NONE', value: 0},
  {label: 'ATTENDANCE_SETTING_BASIC_SETTINGS.ATTENDANCE_STATUS.SMS.ONLY_ABSENT', value: 1},
  {label: 'ATTENDANCE_SETTING_BASIC_SETTINGS.ATTENDANCE_STATUS.SMS.ABSENT_PRESENT', value: 2},
  {
    label: 'ATTENDANCE_SETTING_BASIC_SETTINGS.ATTENDANCE_STATUS.SMS.ABSENT_PRESENT_LATE_PRESENT',
    value: 3,
  },
  {label: 'ATTENDANCE_SETTING_BASIC_SETTINGS.ATTENDANCE_STATUS.SMS.ONLY_PRESENT', value: 4},
  {label: 'ATTENDANCE_SETTING_BASIC_SETTINGS.ATTENDANCE_STATUS.SMS.PRESENT_LATE_PRESENT', value: 5},
  {label: 'ATTENDANCE_SETTING_BASIC_SETTINGS.ATTENDANCE_STATUS.SMS.ONLY_LATE_PRESENT', value: 6},
  {label: 'ATTENDANCE_SETTING_BASIC_SETTINGS.ATTENDANCE_STATUS.SMS.LATE_PRESENT_ABSENT', value: 7},
]

export const SEND_ATTENDANCE_NOTIFICATION_FOR = [
  {label: 'ATTENDANCE_SETTING.BASIC_SETTINGS.NOTIFICATION.NONE', value: 0},
  {label: 'ATTENDANCE_SETTING.BASIC_SETTINGS.NOTIFICATION.ONLY_ABSENT', value: 1},
  {label: 'ATTENDANCE_SETTING.BASIC_SETTINGS.NOTIFICATION.ABSENT_PRESENT_LATE', value: 2},
]

export const SEND_ATTENDANCE_CHECKOUT_NOTIFICATION_SMS_FOR = [
  {label: 'ATTENDANCE_SETTING.CHECKOUT_SETTINGS.NOTIFICATION_SMS.NONE', value: 0},
  {label: 'ATTENDANCE_SETTING.CHECKOUT_SETTINGS.NOTIFICATION_SMS.EARLY_CHECKOUT', value: 1},
  {
    label: 'ATTENDANCE_SETTING.CHECKOUT_SETTINGS.NOTIFICATION_SMS.EARLY_CHECKOUT_ON_TIME_CHECKOUT',
    value: 2,
  },
]

export const WEEKEND_DAYS = [
  {label: 'ATTENDANCE_SETTING.BIOMETRIC_SETTINGS.WEEKEND_DAYS.FRIDAY', value: 'friday'},
  {label: 'ATTENDANCE_SETTING.BIOMETRIC_SETTINGS.WEEKEND_DAYS.SATURDAY', value: 'saturday'},
  {label: 'ATTENDANCE_SETTING.BIOMETRIC_SETTINGS.WEEKEND_DAYS.SUNDAY', value: 'sunday'},
]

export const TEACHER_STAFF_ATTENDANCE_TIME = [
  {label: 'ATTENDANCE_SETTING_BIOMETRIC_SETTINGS.FROM_SETTING', value: 0},
  {label: 'ATTENDANCE_SETTING_BIOMETRIC_SETTINGS.FROM_SCHEDULE', value: 1},
  {label: 'ATTENDANCE_SETTING_BIOMETRIC_SETTINGS.FROM_TIME_TABLE', value: 2},
]

export const STUDENT_ATTENDANCE_TIME = [
  {label: 'ATTENDANCE_SETTING_BIOMETRIC_SETTINGS.FROM_SETTING', value: 0},
  {label: 'ATTENDANCE_SETTING_BIOMETRIC_SETTINGS.FROM_SCHEDULE', value: 1},
]

export const ABSENT_COUNT = [
  {label: '', value: 0},
  {label: '1', value: 1},
  {label: '2', value: 2},
  {label: '3', value: 3},
  {label: '4', value: 4},
  {label: '5', value: 5},
  {label: '6', value: 6},
  {label: '7', value: 7},
  {label: '8', value: 8},
  {label: '9', value: 9},
  {label: '10', value: 10},
  {label: '11', value: 11},
  {label: '12', value: 12},
]

export const FIRST_CHECKOUT_LAST_CHECKOUT = [
  {label: 'ATTENDANCE_SETTING.BIOMETRIC_SETTINGS.FIRST_CHECKOUT', value: 0},
  {label: 'ATTENDANCE_SETTING.BIOMETRIC_SETTINGS.LAST_CHECKOUT', value: 1},
]

export const ATTENDANCE_REMARKS_TYPES = [
  {label: 'USER.STDHEADING', value: 1},
  {label: 'MENU.TEACHERS', value: 2},
]

export const ATTENDANCE_STATUS = {
  STATUS_ABSENT: 0,
  STATUS_PRESENT: 1,
  STATUS_LEAVE: 2,
  STATUS_LATE_PRESENT: 3,
  STATUS_ON_TIME_CHECKOUT: 4,
  STATUS_EARLY_CHECKOUT: 5,
  STATUS_BUNK: 6,
  STATUS_UNMARK: 7,
}

export const ATTENDANCE_SPECIAL_STATUS = {
  SPECIAL_STATUS_NORMAL: 0,
  SPECIAL_STATUS_LATE_COUNT_ABSENT: 1,
  SPECIAL_STATUS_BUNK_ABSENT: 2,
  SPECIAL_STATUS_MARGIN_ABSENT: 3,
}

export const ATTENDANCE_TEACHER_STAFF_TYPES = [
  {label: 'MENU.TEACHERS', value: 2},
  {label: 'MENU.STAFF', value: 5},
]

export const INVOICE_STATUS = {
  PAID: 1,
  UNPAID: 0,
  PARTIAL: 2,
}

export const ATTENDANCE_GRID_TYPES = {
  STUDENT: 1,
  TEACHER_STAFF: 2,
  STUDENT_SUBJECTWISE: 3,
  TEAHCER_STAFF_SUBJECTWISE: 4,
}

export const CLASSES_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
}

export const CLASSES_SUBJECT_STATUS = {
  NO: 0,
  YES: 1,
}

export const SUBJECTS_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
}

export const SUBJECTS_PRACTICAL_STATUS = {
  NO: 0,
  YES: 1,
}

export const SUBJECTS_GRADE_SUBJECT_STATUS = {
  NO: 0,
  YES: 1,
}

export const SUBJECTS_MINOR_SUBJECT_STATUS = {
  NO: 0,
  YES: 1,
}

export const GENERAL_SETTINGS_SUBJECTWISE_PREFERENCES = {
  SUBJECTWISE_PREFERENCE_DISBALED: 0,
  SUBJECTWISE_PREFERENCE_ENABLED: 1,
}

export const ATTENDANCE_SETTING_ATTENDANCE_EDIT_OPTIONS = {
  DISBALED: 0,
  ENABLED: 1,
}

export const ATTENDANCE_SETTING_TEACHER_STAFF_LATE_ATTENDANCE_EDIT_OPTIONS = {
  DISBALED: 0,
  ENABLED: 1,
}

export const ATTENDANCE_SETTING_STUDENT_LATE_ATTENDANCE_EDIT_OPTIONS = {
  DISBALED: 0,
  ENABLED: 1,
}

export const ATTENDANCE_SETTING_TEACHER_SUBJECTWISE_LATE_ATTENDANCE_EDIT_OPTIONS = {
  DISBALED: 0,
  ENABLED: 1,
}

export const ATTENDANCE_SETTING_STUDENT_SUBJECTWISE_LATE_ATTENDANCE_EDIT_OPTIONS = {
  DISBALED: 0,
  ENABLED: 1,
}

export const GENERAL_ENABLE_DISABLE = {
  DISABLE: 0,
  ENABLE: 1,
}

export const ATTENDANCE_BIOMETRIC_STATUS = {
  MANUAL: 0,
  NODE_API: 1,
  ZOOM: 2,
  GOOGLE_MEET: 3,
  CAST: 4,
  MIGRATION: 5,
  CSV: 6,
  ATTENDANCE_AMENDMENT_REQUEST: 7,
  DIGITAL_LEAVE: 8,
}

export const ATTENDANCE_BIOMETRIC_STATUS_LABEL = [
  'ATTENDANCE.MARKED_THROUGH.MANUAL',
  'ATTENDANCE.MARKED_THROUGH.NODE_API',
  'ATTENDANCE.MARKED_THROUGH.ZOOM',
  'ATTENDANCE.MARKED_THROUGH.GOOGLE_MEET',
  'ATTENDANCE.MARKED_THROUGH.CAST',
  'ATTENDANCE.MARKED_THROUGH.MIGRATION',
  'ATTENDANCE.MARKED_THROUGH.CSV',
  'ATTENDANCE.MARKED_THROUGH.ATTENDANCE_AMENDMENT_REQUEST',
  'ATTENDANCE.MARKED_THROUGH.MANUAL_LEAVE',
]

// export const ATTENDANCE_STATUS_LABEL = [
//   {label: 'ATTENDANCE.ATTENDANCE_GRID.STATUS_ABSENT', value: 0},
//   {label: 'ATTENDANCE.ATTENDANCE_GRID.STATUS_PRESENT', value: 1},
//   {label: 'ATTENDANCE.ATTENDANCE_GRID.STATUS_LEAVE', value: 2},
//   {
//     label: attendance_setting?.late_attendance_text
//       ? attendance_setting?.late_attendance_text
//       : 'ATTENDANCE.ATTENDANCE_GRID.STATUS_LATE',
//     value: 3,
//   },
// ]

export const ATTENDANCE_STATUS_LEAVE = [
  {label: 'ATTENDANCE.ATTENDANCE_GRID.STATUS_LEAVE', value: 2},
]

export const ATTENDANCE_CHECKOUT_STATUS_LABEL = [
  {label: 'ATTENDANCE.ATTENDANCE_GRID.CHECKOUT_ON_TIME_CHECKOUT', value: 4},
  {label: 'ATTENDANCE.ATTENDANCE_GRID.CHECKOUT_EARLY_CHECKOUT', value: 5},
]

export const STUDENT_SUBJECT_COMBINE_ATTENDANCE_REPORT_COLUMNS_LABEL = [
  {label: 'STUDENT_SUBJECT_COMBINE_ATTENDANCE_REPORT.COLUMNS.PRESENT', value: 1},
  {label: 'STUDENT_SUBJECT_COMBINE_ATTENDANCE_REPORT.COLUMNS.ABSENT', value: 0},
  {label: 'STUDENT_SUBJECT_COMBINE_ATTENDANCE_REPORT.COLUMNS.LEAVE', value: 2},
  {label: 'STUDENT_SUBJECT_COMBINE_ATTENDANCE_REPORT.COLUMNS.LATE', value: 3},
  {label: 'STUDENT_SUBJECT_COMBINE_ATTENDANCE_REPORT.COLUMNS.BUNKS', value: 6},
]

export const TEACHER_STAFF_COMBINE_ATTENDANCE_REPORT_COLUMNS_LABEL = [
  {label: 'STUDENT_SUBJECT_COMBINE_ATTENDANCE_REPORT.COLUMNS.PRESENT', value: 1},
  {label: 'STUDENT_SUBJECT_COMBINE_ATTENDANCE_REPORT.COLUMNS.ABSENT', value: 0},
  {label: 'STUDENT_SUBJECT_COMBINE_ATTENDANCE_REPORT.COLUMNS.LEAVE', value: 2},
  {label: 'STUDENT_SUBJECT_COMBINE_ATTENDANCE_REPORT.COLUMNS.LATE', value: 3},
  {label: 'STUDENT_SUBJECT_COMBINE_ATTENDANCE_REPORT.COLUMNS.EARLY_CHECKOUT', value: 5},
]

export const TEACHER_SUBJECT_COMBINE_ATTENDANCE_REPORT_COLUMNS_LABEL = [
  {label: 'STUDENT_SUBJECT_COMBINE_ATTENDANCE_REPORT.COLUMNS.PRESENT', value: 1},
  {label: 'STUDENT_SUBJECT_COMBINE_ATTENDANCE_REPORT.COLUMNS.ABSENT', value: 0},
  {label: 'STUDENT_SUBJECT_COMBINE_ATTENDANCE_REPORT.COLUMNS.LEAVE', value: 2},
  {label: 'STUDENT_SUBJECT_COMBINE_ATTENDANCE_REPORT.COLUMNS.LATE', value: 3},
]

export const PARENT_CREATION_TYPE = {
  EXISTING: 'EXISTING',
  NEW: 'NEW',
}

export const CLASS_WISE_INSTANCE = 0
export const SUBJECT_WISE_INSTANCE = 1
export const GRADE_WISE_INSTANCE = 1

export const INACTIVE_REASON_INACTIVE = 0
export const INACTIVE_REASON_NEW_ADMISSION = 1
export const INACTIVE_REASON_ALUMNI = 2
export const INACTIVE_REASON_OTHERS = 3

export const INACTIVE_REASON_LIST = [
  {label: 'Inactive', value: INACTIVE_REASON_INACTIVE},
  {label: 'New Admission', value: INACTIVE_REASON_NEW_ADMISSION},
  {label: 'Alumni', value: INACTIVE_REASON_ALUMNI},
  {label: 'Other', value: INACTIVE_REASON_OTHERS},
]

export const BUILD_VERSION = import.meta.env.VITE_BUILD_VERSION || ''

export const IMAGE_SUPPORTED_EXT = 'image/png, image/jpeg, image/jpg'

export const DOC_EXTS_SUPPORTED = '.pdf, .doc, .docx, .txt, .rtf, .xls, .xlsx, .csv'
export const SIGNATURE_IMAGE_SUPPORTED_EXT = 'image/jpeg, image/jpg'

export const HOMEWORK_RESULTS = {
  PARTIAL: 2,
  COMPLETE: 1,
  NONE: 0,
}

export const TEST_RESULTS = {
  PARTIAL: 2,
  COMPLETE: 1,
  NONE: 0,
}

export const INVOICE_TYPE = {
  GENERATED: 1,
  RECEIVED: 2,
  COLLECTION: 3,
}

export const QUESTION_TYPES = {
  MULTIPLE_CHOICE: 1,
  TRUE_FALSE: 2,
  FILL_IN_THE_BLANK: 3,
  SHORT_TEXT_ANSWER: 4,
  LONG_TEXT_ANSWER: 5,
  DROPDOWN_ANSWER: 6,
}

export const REGISTRATION_STATUS = {
  REGISTERED_AND_ADMITTED: 0,
  ONLY_REGISTERED: 1,
}

export const MARITAL_STATUS = {
  MARRIED: 0,
  SEPARATED: 1,
  DIVORCED: 2,
  WIDOW: 3,
}

export const TEACHER_MARITAL_STATUS = {
  SINGLE: 0,
  MARRIED: 1,
  SEPARATED: 2,
  DIVORCED: 3,
  WIDOW: 4,
}

export const SHOW_ILMVERSITY_LOGO = true

export const DEVICE_TYPES = {
  ANDROID: 1,
  IOS: 2,
  HYBRID: 3,
  HYBRID_ANDROID: 4,
  ANDROID_NEW: 5,
  IOS_NEW: 6,
  WEB: 7,
}

export const ADMISSION_STAGES = {
  INQUIRY_STAGE: 0,
  INTERVIEW_SCHEDULED: 1,
  INTERVIEW_DONE: 2,
  ADMISSION_OFFERED: 3,
  ADMISSION_APPROVED: 4,
  ADMISSION_NOT_APPROVED: 5,
  OTHER_STAGE: 6,
  STAGE_7: 7,
  STAGE_8: 8,
  STAGE_9: 9,
  STAGE_10: 10,
}

/** admission_stage.type of a student stage (1 = admission stage) */
export const STUDENT_STAGE_TYPE = 2

export const PREVIOUS_GRADING = [
  {id: 1, is_default: 1, A: 74, B: 65, C: 55},
  {id: 2, is_default: 0, A: 69, B: 60, C: 50},
  {id: 3, is_default: 0, A: 59, B: 50, C: 40},
  {id: 4, is_default: 0, A: 49, B: 40, C: null},
]

export const ACAD_HISTORY_RECORD_TYPE = {
  CIE_GRADES: 1,
  EXAM_MARKS: 2,
}

export const ACAD_HISTORY_RECORD_LIST = [
  {value: ACAD_HISTORY_RECORD_TYPE.CIE_GRADES, label: 'CIE Grades'},
  {value: ACAD_HISTORY_RECORD_TYPE.EXAM_MARKS, label: 'Exam Marks'},
]

export const SUPPORT_EMAIL = 'support@ilmversity.com'

export const DAYS_OF_THE_WEEK_VALUES = [
  {label: 'SUNDAY', value: 0},
  {label: 'MONDAY', value: 1},
  {label: 'TUESDAY', value: 2},
  {label: 'WEDNESDAY', value: 3},
  {label: 'THURSDAY', value: 4},
  {label: 'FRIDAY', value: 5},
  {label: 'SATURDAY', value: 6},
]

export const HOURS_IN_A_DAY_VALUES = [
  {label: '12:00 AM', value: '00:00:00'},
  {label: '1:00 AM', value: '01:00:00'},
  {label: '2:00 AM', value: '02:00:00'},
  {label: '3:00 AM', value: '03:00:00'},
  {label: '4:00 AM', value: '04:00:00'},
  {label: '5:00 AM', value: '05:00:00'},
  {label: '6:00 AM', value: '06:00:00'},
  {label: '7:00 AM', value: '07:00:00'},
  {label: '8:00 AM', value: '08:00:00'},
  {label: '9:00 AM', value: '09:00:00'},
  {label: '10:00 AM', value: '10:00:00'},
  {label: '11:00 AM', value: '11:00:00'},
  {label: '12:00 PM', value: '12:00:00'},
  {label: '1:00 PM', value: '13:00:00'},
  {label: '2:00 PM', value: '14:00:00'},
  {label: '3:00 PM', value: '15:00:00'},
  {label: '4:00 PM', value: '16:00:00'},
  {label: '5:00 PM', value: '17:00:00'},
  {label: '6:00 PM', value: '18:00:00'},
  {label: '7:00 PM', value: '19:00:00'},
  {label: '8:00 PM', value: '20:00:00'},
  {label: '9:00 PM', value: '21:00:00'},
  {label: '10:00 PM', value: '22:00:00'},
  {label: '11:00 PM', value: '23:00:00'},
]

export const JWT_EXPIRY_OPTIONS = {
  ONE_DAY: '24h',
  ONE_MONTH: '30d',
  ONE_YEAR: '365d',
  NEVER: '100y',
}

export const USER_PERMISSIONS = {
  ADMIN: 0,
  PARENT: 3,
  TEACHER: 2,
  STUDENT: 1,
  STAFF: 5,
}

export default constants
